var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHero(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "gridItem__media",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 1600,
    height: 1200,
    viewBox: "0 0 1600 1200",
    style: {
      baselineShift: 0,
      clipRule: "nonzero",
      color: "rgb(61, 61, 61)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      cursor: "auto",
      direction: "ltr",
      display: "block",
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      font: "400 16px / 18.4px Lato, sans-serif",
      imageRendering: "auto",
      letterSpacing: "normal",
      marker: "none",
      overflow: "hidden",
      paintOrder: "normal",
      pointerEvents: "auto",
      shapeRendering: "auto",
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      textAnchor: "start",
      textDecoration: "none solid rgb(61, 61, 61)",
      textRendering: "auto",
      visibility: "visible",
      wordSpacing: 0,
      writingMode: "horizontal-tb"
    },
    fill: "none",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M735.2 960.43H167.45L137.85 660.61C137.179 653.856 138.529 647.055 141.73 641.07L216.87 500.6C219.644 495.409 223.721 491.029 228.7 487.89L337.83 419.32C343.158 415.967 349.325 414.188 355.62 414.19H480.24C485.089 414.197 489.878 415.257 494.277 417.296C498.677 419.335 502.581 422.305 505.72 426L624.47 564.68C626.484 567.035 628.812 569.101 631.39 570.82L710.91 623.88C715.424 626.906 719.148 630.967 721.773 635.724C724.398 640.482 725.847 645.798 726 651.23L735.2 960.43Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M735.2 960.43H167.45L137.85 660.61C137.179 653.856 138.529 647.055 141.73 641.07L216.87 500.6C219.644 495.409 223.721 491.029 228.7 487.89L337.83 419.32C343.158 415.967 349.325 414.188 355.62 414.19H480.24C485.089 414.197 489.878 415.257 494.277 417.296C498.677 419.335 502.581 422.305 505.72 426L624.47 564.68C626.484 567.035 628.812 569.101 631.39 570.82L710.91 623.88C715.424 626.906 719.148 630.967 721.773 635.724C724.398 640.482 725.847 645.798 726 651.23L735.2 960.43Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.21 741.9H364.54L333.66 959.52H327.66L349.21 741.9Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M349.21 741.9H364.54L333.66 959.52H327.66L349.21 741.9Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.67 959.52H330.24L354.59 751.91C354.686 750.768 355.172 749.694 355.966 748.868C356.76 748.041 357.813 747.513 358.95 747.37L363.95 746.86L364.57 741.98H349.22L327.67 959.52Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.15 741.9H317.48L286.58 959.52H280.58L302.15 741.9Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M302.15 741.9H317.48L286.58 959.52H280.58L302.15 741.9Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.58 959.52H283.15L298.85 830.71C298.85 830.71 299.85 830.71 304.6 827.77L316.78 746.77L317.4 741.9H302.07L280.58 959.52Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.84 959.64H463.84L437.5 745.85H452.81L469.84 959.64Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M469.84 959.64H463.84L437.5 745.85H452.81L469.84 959.64Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466 959.64L454.42 834.83L458.75 829.33L452.28 745.77H437.43L463.8 959.55H466.05L466 959.64Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M327.67 959.46H330.24L354.59 751.85C354.686 750.708 355.172 749.634 355.966 748.808C356.76 747.981 357.813 747.453 358.95 747.31L363.95 746.8L364.57 741.92H349.22L327.67 959.46Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M280.58 959.46H283.15L298.85 830.65C298.85 830.65 299.85 830.65 304.6 827.71L316.78 746.71L317.4 741.84H302.07L280.58 959.46Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M466 959.58L454.42 834.77L458.75 829.27L452.28 745.71H437.43L463.8 959.49H466.05L466 959.58Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.78 730.01H289.44C286.8 730.01 284.66 732.15 284.66 734.79V743.93C284.66 746.57 286.8 748.71 289.44 748.71H466.78C469.42 748.71 471.56 746.57 471.56 743.93V734.79C471.56 732.15 469.42 730.01 466.78 730.01Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M466.78 730.01H289.44C286.8 730.01 284.66 732.15 284.66 734.79V743.93C284.66 746.57 286.8 748.71 289.44 748.71H466.78C469.42 748.71 471.56 746.57 471.56 743.93V734.79C471.56 732.15 469.42 730.01 466.78 730.01Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.28 622.61H590.28L591.28 622.52V622.61Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.92 602.66L567 604.41L595 601.92C597.431 601.971 599.747 602.964 601.46 604.69L618.72 620.11C619.245 620.583 619.567 621.24 619.619 621.944C619.671 622.648 619.449 623.345 619 623.89V623.89C618.552 624.442 617.908 624.798 617.203 624.884C616.498 624.97 615.787 624.778 615.22 624.35L598.88 612.35L609.49 624.9C609.77 625.228 609.966 625.618 610.063 626.038C610.16 626.457 610.154 626.894 610.046 627.311C609.938 627.728 609.731 628.113 609.443 628.433C609.155 628.753 608.793 628.999 608.39 629.15V629.15C607.922 629.32 607.417 629.358 606.928 629.261C606.44 629.164 605.988 628.935 605.62 628.6L591.4 614.66L602.2 625.27C602.496 625.559 602.714 625.917 602.836 626.312C602.957 626.707 602.978 627.126 602.895 627.531C602.813 627.936 602.63 628.314 602.363 628.63C602.097 628.946 601.755 629.19 601.37 629.34V629.34C600.979 629.501 600.554 629.56 600.134 629.511C599.714 629.462 599.313 629.307 598.97 629.06L583.82 618L594.07 625.57C594.349 625.77 594.576 626.033 594.732 626.339C594.889 626.644 594.971 626.982 594.971 627.325C594.971 627.668 594.889 628.006 594.732 628.311C594.576 628.617 594.349 628.88 594.07 629.08C593.768 629.3 593.416 629.44 593.046 629.489C592.675 629.538 592.299 629.494 591.95 629.36L578.19 623.63C577.531 623.348 576.82 623.212 576.104 623.229C575.388 623.246 574.684 623.417 574.04 623.73L568.78 626.31C565.62 627.8 561.22 627.48 556.51 627.48L546 627C547.91 619.61 553.92 602.66 553.92 602.66Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M581.29 622C584.43 623.57 589.69 626.25 591.53 627.26C594.12 628.74 594.86 626.8 594.86 626.8C594.955 627.224 594.928 627.667 594.781 628.076C594.634 628.485 594.373 628.843 594.03 629.11C593.726 629.33 593.372 629.47 593 629.519C592.629 629.568 592.25 629.524 591.9 629.39L578.15 623.66C577.491 623.378 576.78 623.242 576.064 623.259C575.348 623.276 574.644 623.447 574 623.76L576.67 622.19C577.371 621.799 578.155 621.578 578.957 621.545C579.76 621.512 580.559 621.668 581.29 622V622Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    style: {
      baselineShift: 0,
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M593.21 624.7C593.16 624.706 593.108 624.701 593.06 624.686C593.012 624.67 592.967 624.644 592.93 624.61L583.52 617.69C583.33 617.5 583.24 617.22 583.42 617.04C583.6 616.86 583.89 616.76 584.07 616.95L593.49 623.87C593.587 623.945 593.651 624.055 593.667 624.177C593.684 624.298 593.653 624.421 593.58 624.52C593.477 624.615 593.348 624.678 593.21 624.7V624.7Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    style: {
      baselineShift: 0,
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M601.18 624.09C601.08 624.09 600.9 624.09 600.9 624L590.75 614C590.705 613.959 590.669 613.909 590.644 613.853C590.619 613.797 590.607 613.736 590.607 613.675C590.607 613.614 590.619 613.553 590.644 613.497C590.669 613.441 590.705 613.391 590.75 613.35C590.792 613.308 590.842 613.274 590.897 613.251C590.952 613.228 591.011 613.216 591.07 613.216C591.13 613.216 591.189 613.228 591.243 613.251C591.298 613.274 591.348 613.308 591.39 613.35L601.54 623.35C601.585 623.391 601.621 623.441 601.646 623.497C601.671 623.553 601.683 623.614 601.683 623.675C601.683 623.736 601.671 623.797 601.646 623.853C601.621 623.909 601.585 623.959 601.54 624C601.434 624.072 601.307 624.103 601.18 624.09V624.09Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M642.47 924.73L657.95 956.73H700.2L703.75 942.37L689.35 935C688.134 934.377 687.214 933.298 686.79 932L679.9 911.33L642.47 924.73Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M655.47 932.89L682.59 919.4L679.9 911.34L642.47 924.73L657.95 956.73H667.75L654.57 936.18C654.392 935.911 654.274 935.606 654.223 935.287C654.173 934.969 654.19 934.643 654.275 934.331C654.361 934.02 654.511 933.73 654.717 933.482C654.923 933.233 655.18 933.032 655.47 932.89V932.89Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.73 942.34L538.18 956.7H495.93V921.11L529.27 919V928V934.32C529.7 935.615 530.619 936.692 531.83 937.32L541.73 942.34Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M529.29 928L503.29 932.35C502.656 932.456 502.088 932.802 501.703 933.316C501.317 933.83 501.144 934.472 501.22 935.11L503.81 956.73H495.9V928H529.29Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.11 956.45C735.023 954.364 734.316 952.35 733.08 950.667C731.844 948.984 730.135 947.708 728.17 947L699.73 938.36C699.227 938.196 698.68 938.237 698.208 938.475C697.736 938.713 697.377 939.128 697.21 939.63C696.13 943.23 693.42 950.97 688.12 956.46L657.56 956.36C657.03 956.36 656.521 956.571 656.146 956.946C655.771 957.321 655.56 957.83 655.56 958.36C655.56 958.89 655.771 959.399 656.146 959.774C656.521 960.149 657.03 960.36 657.56 960.36L733.13 960.46C733.66 960.46 734.169 960.249 734.544 959.874C734.919 959.499 735.13 958.99 735.13 958.46V956.46L735.11 956.45Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.27 955.78V957.71C570.265 958.219 570.059 958.706 569.698 959.065C569.337 959.425 568.849 959.627 568.34 959.63L494.6 959.53C494.336 959.549 494.07 959.513 493.82 959.425C493.57 959.337 493.341 959.199 493.147 959.018C492.952 958.837 492.798 958.619 492.692 958.376C492.586 958.132 492.531 957.87 492.531 957.605C492.531 957.34 492.586 957.078 492.692 956.834C492.798 956.591 492.952 956.373 493.147 956.192C493.341 956.011 493.57 955.873 493.82 955.785C494.07 955.697 494.336 955.661 494.6 955.68L524.42 955.78C529.59 950.41 532.23 942.86 533.29 939.35C533.364 939.105 533.488 938.877 533.653 938.681C533.818 938.484 534.022 938.324 534.251 938.209C534.48 938.094 534.73 938.027 534.986 938.011C535.242 937.996 535.499 938.033 535.74 938.12L554.55 943.84L563.49 946.56C565.405 947.248 567.071 948.49 568.277 950.128C569.483 951.767 570.173 953.727 570.26 955.76V955.76L570.27 955.78Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.13 918L645.41 930.88L551.3 732.88H397.44V663.88L573.17 664.8C584.42 664.36 589.53 671.54 593.57 683.45L682.13 918Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M666 923.69L645.41 930.91L551.52 732.91H397.44V663.91H528.93C548.07 664 552.68 663.91 560.12 678.05L666 923.69Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534 928H489.86C483.95 834 475.86 752.71 478.02 732.9H343.54C333.752 732.9 324.364 729.013 317.441 722.093C310.517 715.174 306.625 705.788 306.62 696V663.83H503.62H504.92C519.76 664.47 531.33 677.01 531.51 691.83L534 928Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M492 714.41C489.41 713.51 357.51 714.41 357.51 714.41C348.85 714.41 341.79 711.41 336.51 706.41C325.42 695.86 325 678.23 335 666.61L337.4 663.83H306.76V696C306.76 705.792 310.65 715.183 317.574 722.106C324.497 729.03 333.888 732.92 343.68 732.92H478.16C476.37 769.59 484.77 845.05 489.71 923.16H504.14C504.14 923.16 493.59 716 492 714.41Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.62 602.57L465.41 582L439.75 515C432.38 495.79 391.21 514.84 392.1 517.43L426.68 604.7C428.81 610.08 432.63 612.41 439.93 613.09L550.22 627.51L554.62 602.57Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.9 549.31L415.64 558.47L411.09 559.59L402.5 530.59L403.3 492.9L423.89 496.28C430.03 498.62 434.67 502.66 436.82 507.53L452.9 549.31Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M443.35 610.82C436.04 610.14 432.22 607.82 430.09 602.43L401.14 514.22C401.08 514.04 391.92 516.92 392.14 517.43L426.72 604.7C428.85 610.08 432.67 612.41 439.97 613.09L550.26 627.51L550.75 624.7L443.35 610.82Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.92 496.32L416.44 552.38L415.64 558.46L414.64 565.88L412.21 584.25L412.03 593.12L411.75 606.63L411.17 634.2V634.89L412.01 645.89L413.01 659.26C413.13 660.689 412.966 662.128 412.527 663.494C412.088 664.86 411.383 666.125 410.452 667.216C409.521 668.308 408.384 669.204 407.104 669.854C405.825 670.503 404.43 670.893 403 671C368.49 673.35 326.21 669.62 309.31 672.84C308.632 672.965 307.935 672.948 307.263 672.791C306.591 672.634 305.96 672.339 305.407 671.926C304.855 671.513 304.394 670.99 304.054 670.39C303.714 669.79 303.501 669.126 303.43 668.44L302.19 651.09L300.12 622.26L291.49 501.77L291.34 499.77L307.8 495.3L310.34 494.62L310.59 494.55L337.21 487.32L385.28 490L403.28 493L423.87 496.38L423.92 496.32Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M414.66 565.89L412.23 584.26L412.05 593.13H317.47V565.89H414.66Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M416.44 552.39L414.66 565.89H317.47V552.39H416.44Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M412.05 593.16L411.77 606.67H317.47V593.16H412.05Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M303.13 664.58L408.48 661.9C408.678 661.014 408.709 660.098 408.57 659.2L302 648.79L303.13 664.58Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M411.29 635L412.29 584.32L417.6 542.91C417.612 542.784 417.599 542.657 417.559 542.536C417.52 542.416 417.455 542.305 417.371 542.211C417.286 542.117 417.183 542.042 417.067 541.99C416.952 541.938 416.827 541.911 416.7 541.91V541.91C416.488 541.909 416.283 541.983 416.12 542.118C415.957 542.253 415.848 542.442 415.81 542.65L407.74 584.35L406.74 635.03L408.58 659.44C408.678 660.861 408.495 662.287 408.041 663.638C407.587 664.988 406.872 666.235 405.936 667.309C405 668.383 403.861 669.261 402.585 669.895C401.309 670.528 399.921 670.904 398.5 671C389.84 671.6 392.95 671.69 403.07 671C404.496 670.901 405.888 670.521 407.166 669.883C408.445 669.244 409.584 668.358 410.519 667.278C411.454 666.197 412.166 664.942 412.614 663.584C413.062 662.227 413.237 660.795 413.13 659.37L411.29 635Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.24 635.11L412 646L406.72 659.56L307.11 652C305.434 651.873 303.775 651.574 302.16 651.11C297.152 649.626 292.681 646.72 289.291 642.746C285.901 638.772 283.736 633.9 283.06 628.72L282.13 622.14L269.78 535.24C268.67 522.88 276.15 509.13 291.46 501.79C292.37 501.35 293.31 500.93 294.28 500.54L307.8 495.27L310.34 494.59L326.21 619.59L411.21 634.24L416.24 635.11Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.21 619.59L300.09 622.24L282.43 624L282.13 622.06L269.13 539.48C267.888 532.605 268.687 525.518 271.427 519.092C274.168 512.666 278.73 507.183 284.55 503.32C286.697 501.927 288.95 500.707 291.29 499.67V499.67L307.75 495.2L310.29 494.52L310.54 494.45L326.21 619.59Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.06 654.32H447.06L448.06 654.23V654.32Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.69 634.37L423.8 636.12L451.8 633.63C454.23 633.685 456.545 634.678 458.26 636.4L475.52 651.81C476.044 652.286 476.365 652.945 476.415 653.651C476.465 654.357 476.241 655.055 475.79 655.6C475.343 656.152 474.698 656.508 473.993 656.594C473.288 656.68 472.577 656.488 472.01 656.06L455.67 644.06L466.29 656.61C466.569 656.938 466.765 657.329 466.862 657.749C466.958 658.17 466.951 658.607 466.842 659.024C466.733 659.441 466.525 659.826 466.236 660.146C465.946 660.465 465.584 660.71 465.18 660.86V660.86C464.712 661.028 464.207 661.066 463.719 660.969C463.231 660.872 462.778 660.645 462.41 660.31L448.2 646.37L459 657C459.296 657.288 459.515 657.645 459.637 658.04C459.758 658.434 459.779 658.853 459.696 659.257C459.613 659.662 459.43 660.039 459.164 660.354C458.897 660.669 458.555 660.912 458.17 661.06V661.06C457.781 661.226 457.355 661.289 456.934 661.241C456.514 661.194 456.113 661.038 455.77 660.79L440.6 649.69L450.84 657.26C451.119 657.46 451.346 657.723 451.502 658.029C451.659 658.334 451.741 658.672 451.741 659.015C451.741 659.358 451.659 659.696 451.502 660.001C451.346 660.307 451.119 660.57 450.84 660.77C450.538 660.991 450.186 661.131 449.815 661.178C449.444 661.226 449.067 661.178 448.72 661.04L435 655.32C434.34 655.04 433.627 654.903 432.91 654.919C432.193 654.934 431.488 655.102 430.84 655.41L425.55 658C422.39 659.49 417.99 659.17 413.28 659.17L402.53 659.25C404.49 651.91 410.69 634.37 410.69 634.37Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M438.06 653.68C441.2 655.25 446.46 657.93 448.31 658.94C450.89 660.42 451.63 658.48 451.63 658.48C451.729 658.904 451.703 659.348 451.556 659.757C451.409 660.167 451.146 660.526 450.8 660.79C450.498 661.011 450.146 661.151 449.775 661.198C449.404 661.245 449.027 661.198 448.68 661.06L434.93 655.34C434.27 655.06 433.557 654.923 432.84 654.939C432.123 654.954 431.418 655.122 430.77 655.43L433.45 653.87C434.147 653.47 434.929 653.245 435.732 653.211C436.534 653.178 437.333 653.339 438.06 653.68Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    style: {
      baselineShift: 0,
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M450 656.41C449.951 656.416 449.901 656.411 449.855 656.396C449.808 656.38 449.765 656.354 449.73 656.32L440.31 649.4C440.13 649.21 440.03 648.93 440.22 648.75C440.255 648.7 440.301 648.657 440.353 648.625C440.406 648.594 440.465 648.573 440.525 648.564C440.586 648.556 440.648 648.56 440.708 648.576C440.767 648.593 440.822 648.621 440.87 648.66L450.28 655.58C450.329 655.616 450.37 655.662 450.401 655.715C450.432 655.767 450.453 655.826 450.461 655.886C450.47 655.947 450.466 656.008 450.45 656.067C450.434 656.126 450.407 656.182 450.37 656.23C450.268 656.327 450.139 656.39 450 656.41Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    style: {
      baselineShift: 0,
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M458 655.8C457.91 655.8 457.72 655.8 457.72 655.71L447.57 645.71C447.525 645.668 447.488 645.617 447.462 645.561C447.437 645.504 447.423 645.443 447.422 645.381C447.421 645.319 447.432 645.258 447.455 645.2C447.478 645.143 447.513 645.09 447.557 645.046C447.6 645.003 447.653 644.968 447.71 644.945C447.768 644.922 447.829 644.911 447.891 644.912C447.953 644.913 448.014 644.927 448.071 644.952C448.127 644.978 448.178 645.014 448.22 645.06L458.37 655.06C458.456 655.146 458.505 655.263 458.505 655.385C458.505 655.507 458.456 655.624 458.37 655.71C458.261 655.782 458.13 655.813 458 655.8V655.8Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M536.15 929.11H487.21L486.88 921.67H536.15V929.11Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M504.14 929.11H487.25L486.88 921.67H504.14V929.11Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.35 916.3L641.09 932.3L638.35 925.37L684.92 909.27L687.35 916.3Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M665.52 923.85L641.21 932.25L638.35 925.37L663.09 916.82L665.52 923.85Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.17 447.27L389.39 439.78C390.139 435.256 389.161 430.616 386.65 426.78L383.91 422.6C381.413 418.776 377.576 416.025 373.153 414.887C368.731 413.749 364.042 414.306 360.01 416.45L358.71 417.14C356.349 418.393 354.291 420.148 352.68 422.282C351.07 424.415 349.947 426.876 349.39 429.49V429.49C348.809 431.181 348.401 432.927 348.17 434.7L346.88 442.65L345.49 452.43L339.84 490.32H387L385.65 462.74C386.395 460.471 386.868 458.121 387.06 455.74C387.4 452.8 387.79 449.93 388.17 447.27Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.658 419.544C410.317 412.927 405.176 406.998 398.175 406.3C391.173 405.603 384.963 410.401 384.304 417.018C383.644 423.635 388.786 429.564 395.787 430.262C402.789 430.959 408.999 426.161 409.658 419.544Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398 412.15C398 412.15 406.33 473.56 375.13 474.54C348.13 475.44 349.33 433.61 349.33 433.61L353.33 406.8L398 412.15Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.74 466.85C381.693 466.712 381.617 466.587 381.517 466.481C381.417 466.376 381.295 466.294 381.16 466.241C381.025 466.188 380.879 466.164 380.734 466.173C380.589 466.181 380.448 466.221 380.32 466.29C379.049 466.956 377.588 467.168 376.18 466.89C375.482 466.774 374.807 466.548 374.18 466.22C374.066 466.153 373.941 466.11 373.81 466.092C373.68 466.074 373.547 466.082 373.42 466.116C373.293 466.149 373.173 466.207 373.069 466.287C372.964 466.367 372.876 466.466 372.81 466.58C371.49 468.76 369.41 471.23 366.48 471.85C366.236 471.893 366.011 472.009 365.835 472.182C365.658 472.356 365.539 472.579 365.492 472.822C365.446 473.065 365.474 473.316 365.574 473.543C365.673 473.769 365.839 473.96 366.05 474.09C369.87 476.4 376.84 478.82 385.1 473.35C385.262 473.24 385.395 473.093 385.489 472.922C385.583 472.75 385.634 472.558 385.639 472.363C385.644 472.167 385.602 471.973 385.517 471.797C385.432 471.621 385.306 471.468 385.15 471.35C383.574 470.24 382.382 468.667 381.74 466.85V466.85Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.77 385.82C390.82 385.82 386.62 385.76 382.89 385.82C380.25 385.82 377.84 385.82 375.89 385.91C372.1 385.998 368.417 387.186 365.29 389.33C364.509 389.875 363.602 390.21 362.654 390.303C361.707 390.395 360.751 390.243 359.88 389.86C358.89 389.402 357.839 389.089 356.76 388.93C356.23 388.858 355.695 388.821 355.16 388.82C352.595 388.815 350.106 389.686 348.105 391.291C346.104 392.895 344.712 395.136 344.16 397.64V397.64C344.16 397.64 343.78 400.22 340.05 402.14C339.88 402.21 339.72 402.3 339.56 402.38L339.1 402.59L338.83 402.72C333.83 405.43 330.4 411.28 330.4 418.07C330.4 427.44 336.98 435.07 345.11 435.07C347.063 435.069 348.991 434.628 350.75 433.78L350.87 434.95C350.914 435.278 351.07 435.58 351.313 435.805C351.556 436.029 351.87 436.162 352.2 436.18H352.25C352.436 436.197 352.624 436.175 352.8 436.113C352.977 436.052 353.138 435.954 353.274 435.825C353.409 435.696 353.516 435.54 353.586 435.366C353.656 435.193 353.688 435.007 353.68 434.82L353.78 431.82L353.88 428.82C353.93 428.385 354.136 427.982 354.459 427.686C354.783 427.391 355.202 427.222 355.64 427.21H355.75C356.429 427.213 357.104 427.109 357.75 426.9C358.995 426.499 360.079 425.71 360.844 424.648C361.609 423.587 362.014 422.308 362 421C362.087 419.371 362.799 417.839 363.987 416.721C365.176 415.604 366.749 414.987 368.38 415L385.66 415.47H386.78L395.78 415.72C396.812 415.664 397.827 415.431 398.78 415.03V415.03C402.223 414.031 405.19 411.823 407.136 408.812C409.082 405.801 409.876 402.189 409.372 398.639C408.869 395.089 407.102 391.841 404.395 389.489C401.689 387.138 398.225 385.842 394.64 385.84L394.77 385.82Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M347.3 444.86C347.3 444.86 349.85 445.32 351.3 444.37L346.3 450.65L347.3 444.86Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M385.81 480.75L385.74 471.08C382.91 473.49 375.34 476.47 367.15 473.66C363.05 472.196 359.519 469.473 357.06 465.88C357.017 465.808 356.96 465.746 356.892 465.697C356.825 465.649 356.748 465.614 356.666 465.596C356.585 465.579 356.5 465.578 356.418 465.594C356.336 465.61 356.259 465.643 356.19 465.69C356.118 465.734 356.055 465.792 356.007 465.86C355.958 465.929 355.923 466.007 355.906 466.089C355.888 466.172 355.887 466.257 355.903 466.339C355.919 466.422 355.952 466.5 356 466.57C359.205 471.141 364.002 474.351 369.45 475.57C371.691 477.485 374.294 478.931 377.104 479.821C379.914 480.711 382.875 481.027 385.81 480.75V480.75Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M378.62 462.53C378.62 462.63 378.51 462.62 378.62 462.53L374.84 462.45C374.621 462.435 374.416 462.336 374.267 462.174C374.118 462.012 374.037 461.8 374.04 461.58C374.038 461.468 374.06 461.357 374.104 461.254C374.148 461.151 374.213 461.058 374.295 460.981C374.377 460.905 374.474 460.847 374.58 460.81C374.686 460.774 374.798 460.76 374.91 460.77L378.59 460.84C379.09 460.89 379.45 461.22 379.41 461.61C379.36 462.21 379 462.57 378.62 462.53Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M380.36 459.11C373.56 459.43 370.86 455.47 369.95 453.59C369.897 453.493 369.865 453.385 369.855 453.275C369.846 453.165 369.86 453.053 369.896 452.948C369.931 452.844 369.989 452.747 370.064 452.666C370.139 452.584 370.23 452.519 370.331 452.475C370.433 452.43 370.543 452.407 370.653 452.407C370.764 452.407 370.874 452.43 370.975 452.475C371.077 452.52 371.168 452.585 371.243 452.667C371.317 452.749 371.374 452.845 371.41 452.95C372.22 454.82 375.19 459 383.54 457.14C383.641 457.118 383.744 457.115 383.846 457.133C383.947 457.151 384.044 457.189 384.131 457.244C384.218 457.299 384.293 457.371 384.352 457.455C384.411 457.539 384.453 457.635 384.475 457.735C384.497 457.835 384.5 457.939 384.482 458.041C384.464 458.142 384.426 458.239 384.371 458.326C384.316 458.413 384.244 458.488 384.16 458.547C384.076 458.606 383.981 458.648 383.88 458.67C382.725 458.936 381.545 459.083 380.36 459.11V459.11Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.1 440.45C374.47 440.45 375.58 439.34 375.58 437.97C375.58 436.6 374.47 435.49 373.1 435.49C371.73 435.49 370.62 436.6 370.62 437.97C370.62 439.34 371.73 440.45 373.1 440.45Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.27 437.79C374.546 437.79 374.77 437.566 374.77 437.29C374.77 437.014 374.546 436.79 374.27 436.79C373.994 436.79 373.77 437.014 373.77 437.29C373.77 437.566 373.994 437.79 374.27 437.79Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.63 442.5C394 442.5 395.11 441.39 395.11 440.02C395.11 438.65 394 437.54 392.63 437.54C391.26 437.54 390.15 438.65 390.15 440.02C390.15 441.39 391.26 442.5 392.63 442.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.79 439.84C394.066 439.84 394.29 439.616 394.29 439.34C394.29 439.064 394.066 438.84 393.79 438.84C393.514 438.84 393.29 439.064 393.29 439.34C393.29 439.616 393.514 439.84 393.79 439.84Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M382.73 453.28L379.46 453.16C379.277 453.133 379.111 453.041 378.992 452.899C378.874 452.757 378.812 452.577 378.818 452.393C378.824 452.208 378.898 452.032 379.026 451.899C379.154 451.766 379.326 451.684 379.51 451.67L382.78 451.8C383.178 451.813 383.565 451.668 383.855 451.396C384.146 451.124 384.317 450.748 384.33 450.35C384.343 449.952 384.198 449.565 383.926 449.275C383.654 448.984 383.278 448.813 382.88 448.8C382.691 448.775 382.516 448.686 382.385 448.548C382.254 448.409 382.174 448.23 382.16 448.04C382.1 447.64 382.52 447.38 382.92 447.32C383.696 447.348 384.431 447.677 384.97 448.237C385.509 448.796 385.81 449.543 385.81 450.32C385.779 451.116 385.441 451.869 384.866 452.421C384.292 452.973 383.526 453.281 382.73 453.28Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "mask-in-svg",
    style: {
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.44 443.06L349.79 428.65L358.45 445.94L352.92 461.84L345.44 443.06ZM350.17 431.58L346.74 442.94L352.74 458.74L357.14 446.09L350.17 431.58Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357 443.55C357 443.55 376.33 451.34 398.27 448.92C398.27 448.92 395.61 469.7 380.96 475.6C380.96 475.6 362.48 480.23 351.75 460.26C351.76 460.26 356.41 451.61 357 443.55Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M353.37 456.84C355.268 452.627 356.493 448.143 357 443.55C357 443.55 376.33 451.34 398.27 448.92C398.27 448.92 396.9 459.59 390.73 467.81C390.72 467.81 369.73 476.37 353.37 456.84Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M398.27 448.92L396.32 456.86C396.32 456.86 376.58 463.25 355.64 450.61C356.25 448.565 356.679 446.47 356.92 444.35L357.09 443.58C358.44 444.11 377.14 451.25 398.27 448.92Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M350.38 429C350.38 429 348.97 423.18 342.79 425.16C335.79 427.45 335.66 442.78 346.91 444.81C352.78 445.89 351.91 442.32 351.42 437.59L350.38 429Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M342.1 429.1C342.591 428.788 343.139 428.578 343.713 428.482C344.287 428.385 344.874 428.405 345.44 428.54C345.976 428.736 346.464 429.044 346.871 429.444C347.278 429.845 347.595 430.327 347.8 430.86C348.398 432.192 348.633 433.658 348.48 435.11V436.41C348.473 436.501 348.447 436.589 348.404 436.67C348.361 436.751 348.303 436.822 348.231 436.879C348.16 436.936 348.078 436.978 347.99 437.002C347.902 437.027 347.81 437.033 347.72 437.02C347.629 437.014 347.54 436.989 347.459 436.948C347.378 436.906 347.307 436.849 347.249 436.778C347.19 436.708 347.147 436.627 347.122 436.54C347.096 436.452 347.089 436.36 347.1 436.27V434.98C347.176 433.772 346.992 432.561 346.56 431.43C346.46 431.049 346.268 430.699 346 430.411C345.732 430.123 345.397 429.905 345.024 429.779C344.652 429.652 344.253 429.619 343.865 429.684C343.477 429.749 343.111 429.909 342.8 430.15C342.628 430.238 342.428 430.257 342.242 430.203C342.057 430.149 341.898 430.027 341.8 429.86C341.64 429.75 341.78 429.37 342.1 429.1Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.71 429.63C393.608 429.565 392.505 429.721 391.464 430.089C390.423 430.456 389.467 431.028 388.65 431.77C386.858 433.402 385.668 435.589 385.27 437.98C384.799 437.726 384.276 437.581 383.741 437.557C383.206 437.533 382.672 437.629 382.18 437.84C381.86 432.75 378.34 428.6 373.8 428.3C372.698 428.234 371.594 428.389 370.553 428.756C369.512 429.124 368.556 429.696 367.74 430.44C366.121 431.898 364.99 433.818 364.5 435.94L362.4 435.48C362.297 435.457 362.19 435.455 362.086 435.473C361.982 435.491 361.883 435.53 361.794 435.586C361.704 435.643 361.627 435.716 361.567 435.803C361.506 435.889 361.463 435.987 361.44 436.09C361.417 436.193 361.414 436.3 361.433 436.404C361.451 436.508 361.489 436.607 361.546 436.696C361.603 436.785 361.676 436.863 361.763 436.923C361.849 436.984 361.947 437.027 362.05 437.05L364.23 437.52C364.23 437.7 364.23 437.88 364.18 438.07C363.84 443.78 367.61 448.71 372.57 449.07H373.1C375.145 449.05 377.112 448.282 378.63 446.91C380.678 445.026 381.936 442.435 382.15 439.66C382.573 439.315 383.11 439.141 383.655 439.175C384.2 439.208 384.712 439.446 385.09 439.84C384.96 445.37 388.65 450.05 393.48 450.38H394.02C396.062 450.359 398.026 449.591 399.54 448.22C400.607 447.245 401.472 446.069 402.084 444.76C402.697 443.451 403.045 442.034 403.11 440.59C403.44 434.88 399.67 430 394.71 429.63ZM377.57 445.7C376.913 446.302 376.141 446.766 375.301 447.065C374.461 447.364 373.57 447.491 372.68 447.44C368.59 447.17 365.49 443 365.77 438.16C365.77 437.84 365.83 437.53 365.87 437.22C365.896 437.173 365.916 437.122 365.93 437.07C365.945 437.014 365.945 436.956 365.93 436.9C366.274 434.876 367.284 433.024 368.8 431.64C370.025 430.527 371.615 429.901 373.27 429.88H373.69C377.78 430.16 380.87 434.32 380.59 439.17C380.488 441.661 379.402 444.009 377.57 445.7V445.7ZM401.51 440.51C401.411 442.994 400.332 445.338 398.51 447.03C397.85 447.631 397.076 448.094 396.235 448.393C395.394 448.692 394.501 448.82 393.61 448.77C389.52 448.5 386.43 444.33 386.71 439.49C386.809 437.006 387.888 434.662 389.71 432.97C390.37 432.368 391.143 431.903 391.984 431.602C392.825 431.302 393.718 431.172 394.61 431.22C398.69 431.5 401.79 435.66 401.51 440.51Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M319.18 539L325.68 561.6L333.15 612.77L406.77 633.47L326.21 619.6L316.21 539.6C316.165 539.221 316.264 538.839 316.488 538.529C316.712 538.22 317.044 538.006 317.418 537.931C317.793 537.855 318.182 537.923 318.508 538.121C318.835 538.319 319.074 538.633 319.18 539V539Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M410.69 634.37L402.53 659.25L387.76 658.09L396.91 630.71L410.69 634.37Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.811 479.885L338.758 476.799C336.95 476.685 335.393 478.058 335.279 479.866L334.844 486.773C334.731 488.581 336.104 490.138 337.912 490.252L386.965 493.338C388.773 493.452 390.331 492.079 390.444 490.271L390.879 483.364C390.993 481.557 389.619 479.999 387.811 479.885Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.26 955.76H549.56C552.35 953.2 553.69 948.82 554.56 943.84L563.5 946.56C565.413 947.249 567.077 948.492 568.281 950.13C569.485 951.769 570.174 953.729 570.26 955.76Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.12 956.2H714.42C717.21 953.64 718.55 949.26 719.42 944.28L728.36 947C730.273 947.689 731.937 948.932 733.141 950.57C734.345 952.209 735.034 954.169 735.12 956.2V956.2Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M735.11 956.45C735.046 954.807 734.597 953.202 733.8 951.764C733.003 950.326 731.88 949.095 730.52 948.17C734.03 950.69 733.4 953.17 728.36 953.04C702.17 951.77 695.14 951.77 692.08 951.51C692.113 951.474 692.138 951.431 692.154 951.385C692.169 951.338 692.175 951.289 692.17 951.24C691.019 953.085 689.678 954.804 688.17 956.37H657.56C657.03 956.37 656.521 956.581 656.146 956.956C655.771 957.331 655.56 957.84 655.56 958.37C655.56 958.9 655.771 959.409 656.146 959.784C656.521 960.159 657.03 960.37 657.56 960.37H733.21C733.741 960.37 734.249 960.159 734.624 959.784C734.999 959.409 735.21 958.9 735.21 958.37V956.47H735.12L735.11 956.45Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M570.17 955.75C570.112 954.106 569.666 952.498 568.868 951.059C568.071 949.62 566.944 948.39 565.58 947.47C569.09 949.99 568.46 952.47 563.42 952.33C537.23 951.07 531.42 951.07 528.42 950.8C528.457 950.766 528.486 950.724 528.503 950.677C528.521 950.63 528.526 950.58 528.52 950.53C527.366 952.372 526.025 954.091 524.52 955.66H494.65C494.119 955.66 493.611 955.871 493.236 956.246C492.861 956.621 492.65 957.13 492.65 957.66C492.65 958.19 492.861 958.699 493.236 959.074C493.611 959.449 494.119 959.66 494.65 959.66H568.28C568.81 959.66 569.319 959.449 569.694 959.074C570.069 958.699 570.28 958.19 570.28 957.66V955.77H570.19L570.17 955.75Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M372.37 491.11H372.32L334.93 488.66C334.719 488.645 334.523 488.547 334.385 488.387C334.246 488.228 334.176 488.021 334.19 487.81C334.208 487.6 334.306 487.404 334.464 487.264C334.623 487.125 334.829 487.052 335.04 487.06L372.43 489.52C372.535 489.526 372.637 489.553 372.731 489.6C372.825 489.646 372.909 489.711 372.978 489.79C373.047 489.869 373.099 489.961 373.132 490.061C373.165 490.16 373.178 490.265 373.17 490.37C373.155 490.572 373.064 490.76 372.915 490.897C372.767 491.035 372.572 491.111 372.37 491.11V491.11Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.29 657.28H517.89C518.209 657.288 518.512 657.418 518.737 657.643C518.962 657.868 519.092 658.171 519.1 658.49V662.49C519.095 662.809 518.966 663.114 518.74 663.34C518.514 663.566 518.209 663.695 517.89 663.7H438.29C437.972 663.692 437.668 663.562 437.443 663.337C437.218 663.112 437.088 662.808 437.08 662.49V658.49C437.077 658.33 437.107 658.172 437.167 658.024C437.226 657.876 437.315 657.741 437.428 657.628C437.541 657.515 437.676 657.426 437.824 657.367C437.972 657.307 438.13 657.277 438.29 657.28V657.28Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.26 657.28H517.86C518.178 657.288 518.482 657.418 518.707 657.643C518.932 657.868 519.062 658.171 519.07 658.49V662.49C519.065 662.809 518.936 663.114 518.71 663.34C518.484 663.566 518.179 663.695 517.86 663.7H438.26C437.941 663.692 437.638 663.562 437.413 663.337C437.188 663.112 437.058 662.808 437.05 662.49V658.49C437.047 658.33 437.077 658.172 437.137 658.024C437.196 657.876 437.285 657.741 437.398 657.628C437.511 657.515 437.646 657.426 437.794 657.367C437.942 657.307 438.1 657.277 438.26 657.28V657.28Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.84 657.62H630.62C630.938 657.63 631.24 657.761 631.464 657.985C631.689 658.21 631.82 658.512 631.83 658.83V662.83C631.822 663.149 631.692 663.452 631.467 663.677C631.242 663.902 630.938 664.032 630.62 664.04H491.84C491.521 664.032 491.218 663.902 490.993 663.677C490.767 663.452 490.637 663.149 490.63 662.83V658.83C490.653 658.517 490.788 658.222 491.01 658C491.232 657.778 491.527 657.643 491.84 657.62V657.62Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M491.84 657.62H630.62C630.938 657.63 631.24 657.761 631.464 657.985C631.689 658.21 631.82 658.512 631.83 658.83V662.83C631.822 663.149 631.692 663.452 631.467 663.677C631.242 663.902 630.938 664.032 630.62 664.04H491.84C491.521 664.032 491.218 663.902 490.993 663.677C490.767 663.452 490.637 663.149 490.63 662.83V658.83C490.653 658.517 490.788 658.222 491.01 658C491.232 657.778 491.527 657.643 491.84 657.62V657.62Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629 658.59H487.7C487.476 658.566 487.269 658.461 487.119 658.294C486.969 658.127 486.885 657.91 486.885 657.685C486.885 657.46 486.969 657.243 487.119 657.076C487.269 656.909 487.476 656.804 487.7 656.78H629C629.119 656.779 629.238 656.801 629.348 656.847C629.459 656.892 629.559 656.959 629.643 657.044C629.727 657.129 629.793 657.23 629.837 657.341C629.881 657.452 629.903 657.571 629.9 657.69C629.893 657.926 629.795 658.151 629.628 658.318C629.461 658.485 629.236 658.583 629 658.59Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.66 657.28H512.56C513.345 657.282 514.106 657.009 514.71 656.508C515.315 656.008 515.725 655.311 515.87 654.54L533.39 562.43C533.49 561.942 533.48 561.438 533.359 560.954C533.239 560.471 533.011 560.02 532.694 559.637C532.376 559.253 531.976 558.945 531.524 558.736C531.072 558.527 530.578 558.423 530.08 558.43H509.17C508.386 558.432 507.627 558.706 507.024 559.206C506.42 559.706 506.009 560.4 505.86 561.17L488.35 653.29C488.257 653.777 488.273 654.278 488.397 654.758C488.52 655.237 488.748 655.684 489.065 656.065C489.381 656.447 489.778 656.753 490.226 656.963C490.675 657.173 491.165 657.281 491.66 657.28Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.64 657.28H628.89C629.675 657.282 630.436 657.009 631.04 656.508C631.645 656.008 632.055 655.311 632.2 654.54L649.72 562.43C649.82 561.942 649.81 561.438 649.689 560.954C649.569 560.471 649.341 560.02 649.024 559.637C648.706 559.253 648.306 558.945 647.854 558.736C647.402 558.527 646.908 558.423 646.41 558.43H512.24C511.456 558.43 510.696 558.704 510.092 559.204C509.487 559.704 509.077 560.399 508.93 561.17L491.41 653.29C491.301 653.772 491.303 654.272 491.415 654.753C491.527 655.234 491.747 655.684 492.058 656.068C492.369 656.452 492.763 656.76 493.21 656.97C493.657 657.18 494.146 657.286 494.64 657.28V657.28Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M494.64 657.28H628.89C629.675 657.282 630.436 657.009 631.04 656.508C631.645 656.008 632.055 655.311 632.2 654.54L649.72 562.43C649.82 561.942 649.81 561.438 649.689 560.954C649.569 560.471 649.341 560.02 649.024 559.637C648.706 559.253 648.306 558.945 647.854 558.736C647.402 558.527 646.908 558.423 646.41 558.43H512.24C511.456 558.43 510.696 558.704 510.092 559.204C509.487 559.704 509.077 560.399 508.93 561.17L491.41 653.29C491.301 653.772 491.303 654.272 491.415 654.753C491.527 655.234 491.747 655.684 492.058 656.068C492.369 656.452 492.763 656.76 493.21 656.97C493.657 657.18 494.146 657.286 494.64 657.28V657.28Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.34 608.29C575.53 610.15 576.42 611.76 578.27 611.76H578.6C577.548 612.966 576.26 613.943 574.815 614.631C573.37 615.319 571.799 615.703 570.2 615.76C566.2 615.68 564.39 612.45 566.2 608.49C568.01 604.53 572.58 601.49 576.54 601.55C579.04 601.63 580.73 602.92 581.14 604.94C580.116 605.026 579.132 605.381 578.289 605.969C577.446 606.557 576.774 607.358 576.34 608.29V608.29Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.33 664.06H401.43V676.9H699.33V664.06Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M699.33 664.06H401.43V676.9H699.33V664.06Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.03 664.06H401.43V676.9H496.03V664.06Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.35 737.37L683 676.9H504.3H476.68H445.28H417.65L402.88 959.64H410.62L437.86 737.37H475.11L469.34 959.64H477.07L498.48 737.37H687.35Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.2 959.64H705.93L686.38 676.9H678.38H658.76H515.56H495.93H493.74V705.89L474.54 959.64H480.71L508.11 737.37H667.2L698.2 959.64Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M698.2 959.64H705.93L686.38 676.9H678.38H658.76H515.56H495.93H493.74V705.89L474.54 959.64H480.71L508.11 737.37H667.2L698.2 959.64Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.96 685.14H493.74V676.9H686.43L686.96 685.14Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.91 417H392.73C392.646 416.999 392.563 416.981 392.486 416.947C392.409 416.914 392.339 416.866 392.28 416.806C392.222 416.745 392.176 416.674 392.145 416.596C392.114 416.518 392.099 416.434 392.1 416.35C392.1 415.95 392.37 415.68 392.76 415.72H395.94C396.342 415.743 396.745 415.716 397.14 415.64C398.475 415.347 399.763 414.872 400.97 414.23C401.046 414.191 401.129 414.167 401.214 414.16C401.299 414.154 401.385 414.164 401.466 414.191C401.547 414.218 401.622 414.261 401.686 414.318C401.75 414.374 401.803 414.443 401.84 414.52C401.879 414.595 401.902 414.677 401.909 414.762C401.915 414.846 401.905 414.931 401.878 415.012C401.851 415.092 401.808 415.166 401.751 415.229C401.695 415.293 401.627 415.344 401.55 415.38C400.252 416.079 398.857 416.578 397.41 416.86L395.91 417Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.77 756.68C170.51 758.9 170.65 796.35 170.65 796.35C135 789.69 137.64 756.82 137.77 756.68Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.59 762.78C257.89 752.8 249 788.3 249 788.3C289.24 789 296.59 762.78 296.59 762.78Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.24 756.82C195.47 772.77 207 803 207 803C234 786.5 222.38 756.82 222.24 756.82Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.82 795.65C250.68 787.05 241.11 823.65 241.11 823.65C282.44 826.86 289 795.65 288.82 795.65Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M288.82 795.65C250.68 787.05 241.11 823.65 241.11 823.65C282.44 826.86 289 795.65 288.82 795.65Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.16 843.78C228.35 835.18 221.69 861.12 221.69 861.12C251.65 869.72 263 843.78 263.16 843.78Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.2 798.57C194.78 803.57 197.97 844.34 197.97 844.34C150.12 838.37 152.2 798.43 152.2 798.57Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.13 900.27C197.05 899.58 188.31 830.54 168.59 793.15L169.1 792.89C188.86 830.36 197.61 899.51 197.7 900.2L197.13 900.27Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.18 875.42C198.12 837.13 211.57 781.42 211.7 780.88L212.26 781.02C212.12 781.58 198.7 837.18 200.75 875.39L200.18 875.42Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.65 900.24H213.08C212.936 871.68 219.027 843.432 230.93 817.47C239.76 798.56 248.71 788.22 248.8 788.12L249.23 788.49C249.14 788.59 240.23 798.89 231.44 817.73C219.574 843.61 213.502 871.769 213.65 900.24V900.24Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.85 900.25C197.69 828.14 194.48 815.67 188.09 790.83C187.44 788.31 186.76 785.67 186.04 782.83L186.6 782.7C187.31 785.54 187.99 788.18 188.6 790.7C195 815.59 198.21 828.07 202.38 900.24L201.85 900.25Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.4 898.87C217 844.66 229.59 806.39 240.92 783.87C254.18 757.5 270.62 742.57 278.44 738.97L278.68 739.49C270.93 743.06 254.62 757.88 241.43 784.13C230.13 806.61 217.58 844.77 221.97 898.86L221.4 898.87Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.51 899C226.001 886.419 226.088 873.699 227.77 861.14C230.36 842.52 238.14 817.8 260.53 805.78L260.8 806.28C238.62 818.18 230.91 842.72 228.33 861.2C226.66 873.713 226.573 886.386 228.07 898.92L227.51 899Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.76 889.79C195.76 889.67 191.9 878.66 180.18 869.53L180.53 869.08C192.39 878.32 196.26 889.49 196.3 889.6L195.76 889.79Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.82 868.27C191.57 868.06 167.31 846.77 155.31 843.27L155.47 842.73C167.6 846.31 191.95 867.73 192.19 867.89L191.82 868.27Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.34 900.24C209.06 871.17 207.41 721.3 207.4 719.79H208C208 721.3 209.67 871.17 209.95 900.24H209.34Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.78 795.1C237.78 835.32 201.44 833.38 201.44 833.38C202.55 795.52 237.78 795.1 237.78 795.1Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M237.78 795.1C237.78 835.32 201.44 833.38 201.44 833.38C202.55 795.52 237.78 795.1 237.78 795.1Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.85 828.39C157.19 821.31 167.04 849.05 167.04 849.05C131.12 851.69 126 828.39 125.85 828.39Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M125.85 828.39C157.19 821.31 167.04 849.05 167.04 849.05C131.12 851.69 126 828.39 125.85 828.39Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.46 907.59H245.82V899.54H181.46V907.59Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.18 907.59H241.38L237.78 960.43H189.78L186.18 907.59Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M181.6 907.59H186.18L189.79 960.43H201.44L201.58 909.81H241.11L241.38 907.59H192V899.54H181.6V907.59Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.82 698.29C225.99 724.08 208.23 750.99 208.23 750.99C187.43 724.5 202.82 698.29 202.82 698.29Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M202.82 698.29C225.99 724.08 208.23 750.99 208.23 750.99C187.43 724.5 202.82 698.29 202.82 698.29Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.61 737.68C211.56 763.34 192.01 805.09 192.01 805.09C152.62 775.4 176.75 737.68 176.61 737.68Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M176.61 737.68C211.56 763.34 192.01 805.09 192.01 805.09C152.62 775.4 176.75 737.68 176.61 737.68Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.75 862.09C182.57 858.21 187.29 876.38 187.29 876.38C161.77 880.54 157.75 862.09 157.75 862.09Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.5 845.45C226.68 849.61 221.27 884.84 221.27 884.84C186.87 876 194.5 845.45 194.5 845.45Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M194.5 845.45C226.68 849.61 221.27 884.84 221.27 884.84C186.87 876 194.5 845.45 194.5 845.45Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.13 750.58C267.88 731.99 287.29 733.93 287.29 733.93C281.75 752.66 264.13 750.44 264.13 750.58Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M264.13 750.58C267.88 731.99 287.29 733.93 287.29 733.93C281.75 752.66 264.13 750.44 264.13 750.58Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.55 784.42C264.13 757.1 240 732 240 732C216.83 757.65 240.55 784.42 240.55 784.42Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M240.55 784.42C264.13 757.1 240 732 240 732C216.83 757.65 240.55 784.42 240.55 784.42Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M313.07 645.63C311.394 645.503 309.735 645.204 308.12 644.74C303.108 643.259 298.634 640.355 295.24 636.381C291.846 632.406 289.678 627.532 289 622.35L288.07 615.77L275.07 533.19C274.188 528.208 274.364 523.096 275.585 518.186C276.806 513.276 279.047 508.678 282.16 504.69C277.07 508.716 273.169 514.047 270.87 520.116C268.572 526.184 267.964 532.763 269.11 539.15L282.11 621.73L283.04 628.31C283.717 633.49 285.881 638.362 289.271 642.336C292.662 646.31 297.132 649.216 302.14 650.7C303.755 651.164 305.414 651.463 307.09 651.59L406.72 659.16L409.14 652.94L313.07 645.63Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.05,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.44 512.57H135.88V629.18H227.44V512.57Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.22 524.3H148.1V617.45H215.22V524.3Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.27 629.15H135.91V512.54H133.27V629.15Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M215.22 524.3H148.1V617.45H215.22V524.3Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M133.27 629.15H135.91V512.54H133.27V629.15Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.84 567.17C195.842 564.286 194.988 561.466 193.388 559.067C191.787 556.668 189.51 554.798 186.846 553.693C184.182 552.588 181.251 552.298 178.422 552.859C175.593 553.42 172.994 554.808 170.954 556.847C168.914 558.886 167.524 561.483 166.961 564.312C166.397 567.14 166.686 570.072 167.789 572.737C168.892 575.402 170.761 577.68 173.159 579.282C175.557 580.885 178.376 581.74 181.26 581.74C185.125 581.74 188.832 580.205 191.566 577.473C194.3 574.741 195.837 571.035 195.84 567.17V567.17Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.65 559.24L195.1 536.69L180.49 559.51L209.65 559.24Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.49 575.12H155.13V600.47H180.49V575.12Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.93 962.1L804.19 656.56C803.647 643.259 808.364 630.279 817.32 620.43L964.39 461.9C968.856 457.053 974.345 453.261 980.46 450.8L1087.18 408.22C1092.09 406.249 1097.32 405.23 1102.61 405.22H1228C1234.36 405.28 1240.63 406.746 1246.36 409.512C1252.09 412.278 1257.14 416.276 1261.14 421.22L1328.69 502.22C1332.3 506.592 1336.69 510.249 1341.65 513L1409.76 550.42C1424.76 558.66 1434.22 575.34 1434.22 593.56V962.1H814.93Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M814.93 962.1L804.19 656.56C803.647 643.259 808.364 630.279 817.32 620.43L964.39 461.9C968.856 457.053 974.345 453.261 980.46 450.8L1087.18 408.22C1092.09 406.249 1097.32 405.23 1102.61 405.22H1228C1234.36 405.28 1240.63 406.746 1246.36 409.512C1252.09 412.278 1257.14 416.276 1261.14 421.22L1328.69 502.22C1332.3 506.592 1336.69 510.249 1341.65 513L1409.76 550.42C1424.76 558.66 1434.22 575.34 1434.22 593.56V962.1H814.93Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.27 708.49V545.84C1071.27 540.38 1074.89 535.97 1079.37 535.97H1331.13V708.49C1331.13 713.94 1327.5 718.36 1323.02 718.36H1079.37C1074.89 718.36 1071.27 713.94 1071.27 708.49Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041.23 684.5C1041.23 681.88 1040.19 679.367 1038.34 677.514C1036.48 675.661 1033.97 674.62 1031.35 674.62H905.25C903.953 674.62 902.669 674.876 901.47 675.372C900.272 675.869 899.184 676.597 898.267 677.514C897.351 678.432 896.624 679.521 896.128 680.72C895.633 681.918 895.379 683.203 895.38 684.5V962.05H1041.23V684.5Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1041.23 684.5C1041.23 681.88 1040.19 679.367 1038.34 677.514C1036.48 675.661 1033.97 674.62 1031.35 674.62H905.25C903.953 674.62 902.669 674.876 901.47 675.372C900.272 675.869 899.184 676.597 898.267 677.514C897.351 678.432 896.624 679.521 896.128 680.72C895.633 681.918 895.379 683.203 895.38 684.5V962.05H1041.23V684.5Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.94 684.5C927.941 683.203 927.687 681.918 927.192 680.72C926.696 679.521 925.969 678.432 925.053 677.514C924.136 676.597 923.048 675.869 921.849 675.372C920.651 674.876 919.367 674.62 918.07 674.62H872.86C871.564 674.621 870.281 674.878 869.084 675.375C867.887 675.872 866.799 676.601 865.884 677.518C864.968 678.435 864.242 679.524 863.748 680.722C863.253 681.92 862.999 683.204 863 684.5V962.05H928L927.94 684.5Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.88 834.69V769.69H927.88V834.69H1246.88Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1071.27 708.49V545.84C1071.27 540.38 1074.89 535.97 1079.37 535.97H1331.13V708.49C1331.13 713.94 1327.5 718.36 1323.02 718.36H1079.37C1074.89 718.36 1071.27 713.94 1071.27 708.49Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M927.94 684.5C927.941 683.203 927.687 681.918 927.192 680.72C926.696 679.521 925.969 678.432 925.053 677.514C924.136 676.597 923.048 675.869 921.849 675.372C920.651 674.876 919.367 674.62 918.07 674.62H872.86C871.564 674.621 870.281 674.878 869.084 675.375C867.887 675.872 866.799 676.601 865.884 677.518C864.968 678.435 864.242 679.524 863.748 680.722C863.253 681.92 862.999 683.204 863 684.5V962.05H928L927.94 684.5Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1246.88 834.69V769.69H927.88V834.69H1246.88Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221.39 834.67V769.67H1212.21V834.67H1221.39Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1221.39 834.67V769.67H1212.21V834.67H1221.39Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M927.94 843.77V727.46C927.976 727.356 928.044 727.267 928.134 727.203C928.223 727.14 928.33 727.106 928.44 727.106C928.55 727.106 928.657 727.14 928.746 727.203C928.836 727.267 928.904 727.356 928.94 727.46V843.77C928.904 843.874 928.836 843.963 928.746 844.027C928.657 844.09 928.55 844.124 928.44 844.124C928.33 844.124 928.223 844.09 928.134 844.027C928.044 843.963 927.976 843.874 927.94 843.77V843.77Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1312.59 708.49V545.75C1312.59 544.453 1312.85 543.169 1313.34 541.971C1313.84 540.772 1314.57 539.684 1315.48 538.767C1316.4 537.851 1317.49 537.124 1318.69 536.628C1319.89 536.133 1321.17 535.879 1322.47 535.88H1367.67C1368.97 535.879 1370.25 536.133 1371.45 536.628C1372.65 537.124 1373.74 537.851 1374.66 538.767C1375.57 539.684 1376.3 540.772 1376.8 541.971C1377.29 543.169 1377.55 544.453 1377.55 545.75V708.49C1377.55 709.787 1377.29 711.071 1376.8 712.269C1376.3 713.468 1375.57 714.556 1374.66 715.473C1373.74 716.389 1372.65 717.116 1371.45 717.612C1370.25 718.107 1368.97 718.361 1367.67 718.36H1322.47C1321.17 718.361 1319.89 718.107 1318.69 717.612C1317.49 717.116 1316.4 716.389 1315.48 715.473C1314.57 714.556 1313.84 713.468 1313.34 712.269C1312.85 711.071 1312.59 709.787 1312.59 708.49Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1312.59 708.49V545.75C1312.59 544.453 1312.85 543.169 1313.34 541.971C1313.84 540.772 1314.57 539.684 1315.48 538.767C1316.4 537.851 1317.49 537.124 1318.69 536.628C1319.89 536.133 1321.17 535.879 1322.47 535.88H1367.67C1368.97 535.879 1370.25 536.133 1371.45 536.628C1372.65 537.124 1373.74 537.851 1374.66 538.767C1375.57 539.684 1376.3 540.772 1376.8 541.971C1377.29 543.169 1377.55 544.453 1377.55 545.75V708.49C1377.55 709.787 1377.29 711.071 1376.8 712.269C1376.3 713.468 1375.57 714.556 1374.66 715.473C1373.74 716.389 1372.65 717.116 1371.45 717.612C1370.25 718.107 1368.97 718.361 1367.67 718.36H1322.47C1321.17 718.361 1319.89 718.107 1318.69 717.612C1317.49 717.116 1316.4 716.389 1315.48 715.473C1314.57 714.556 1313.84 713.468 1313.34 712.269C1312.85 711.071 1312.59 709.787 1312.59 708.49Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1241.14 509.07C1241.83 509.459 1242.37 510.081 1242.65 510.826C1242.92 511.572 1242.93 512.391 1242.66 513.14L1242.59 513.33C1238.08 525.473 1229.26 535.53 1217.81 541.58L1217.3 541.85C1216.37 542.33 1215.42 542.78 1214.46 543.2C1203.52 547.985 1191.29 548.916 1179.75 545.84C1176.89 545.083 1174.1 544.079 1171.41 542.84C1169.95 542.17 1168.54 541.45 1167.17 540.65C1163.76 538.682 1160.58 536.334 1157.7 533.65C1152.45 528.8 1146.62 517.38 1144.29 512.56C1144.17 512.317 1144.11 512.05 1144.11 511.779C1144.12 511.509 1144.18 511.242 1144.31 511.002C1144.43 510.762 1144.61 510.554 1144.83 510.396C1145.05 510.238 1145.3 510.133 1145.57 510.09C1147.75 509.73 1150.94 508.93 1153 507.15C1155.94 504.79 1158.04 501.547 1159 497.9C1159.13 497.367 1159.23 496.826 1159.29 496.28V496.23C1159.35 495.348 1159.35 494.462 1159.29 493.58V493.58C1159.29 493.39 1159.29 493.18 1159.29 492.99V492.94C1159.21 491.997 1159.05 491.063 1158.8 490.15C1158.8 489.98 1158.72 489.86 1158.71 489.81C1158.45 489.19 1158.22 488.55 1158.01 487.89C1157.57 486.442 1157.26 484.955 1157.1 483.45C1156.33 475.66 1160.31 472.36 1162.48 471.15C1162.85 470.928 1163.16 470.612 1163.38 470.233C1163.59 469.853 1163.7 469.425 1163.69 468.99C1163.43 444.56 1196.25 436.25 1214.78 449.41C1225.95 457.41 1229.16 466.91 1228.99 476.18C1228.98 476.356 1228.98 476.533 1228.99 476.71C1228.9 479.044 1228.95 481.381 1229.12 483.71L1229.25 483.64C1229.49 486.428 1229.91 489.197 1230.51 491.93C1231.62 496.93 1233.51 501.93 1236.72 505.32L1236.81 505.41C1238.03 506.875 1239.49 508.114 1241.14 509.07V509.07Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968 863.32L987.25 919.5C987.743 921.038 987.734 922.692 987.223 924.224C986.712 925.756 985.727 927.086 984.41 928.02C980.53 930.86 975.62 931.25 969.94 933.19L929.78 946.62C925.9 947.91 930.42 955.4 930.42 955.4C930.781 955.882 931.249 956.272 931.787 956.541C932.325 956.811 932.918 956.95 933.52 956.95C934.78 956.923 935.982 956.415 936.88 955.53C937.01 955.4 937.01 955.4 937.14 955.4H937.91C938.04 955.4 938.17 955.53 938.3 955.66C938.652 956.068 939.088 956.394 939.578 956.617C940.068 956.84 940.601 956.953 941.14 956.95C942.334 956.91 943.477 956.454 944.37 955.66C944.46 955.577 944.567 955.515 944.683 955.476C944.799 955.438 944.922 955.424 945.044 955.437C945.166 955.449 945.283 955.487 945.39 955.548C945.496 955.608 945.588 955.691 945.66 955.79C945.952 956.117 946.311 956.376 946.714 956.548C947.117 956.721 947.552 956.804 947.99 956.79C948.958 956.743 949.896 956.432 950.7 955.89C950.895 955.755 951.132 955.694 951.369 955.718C951.605 955.741 951.825 955.849 951.99 956.02C952.557 956.531 953.297 956.806 954.06 956.79C954.59 956.789 955.11 956.645 955.564 956.372C956.018 956.099 956.39 955.708 956.64 955.24H957.03L1013.21 954.34H1010.49C1012.09 954.32 1013.67 953.98 1015.14 953.34C1018.01 952.139 1020.33 949.912 1021.64 947.094C1022.96 944.276 1023.17 941.069 1022.25 938.1L1018.11 924.93L1008.3 861.65L968 863.32Z",
    fill: "#956363",
    style: {
      baselineShift: 0,
      fill: "rgb(149, 99, 99)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1021.89 938.35L1017.76 925.18L1007.94 861.9L968.55 863.45L982.55 866.8C986.624 867.799 990.371 869.835 993.425 872.711C996.479 875.586 998.737 879.203 999.98 883.21L1011.61 921.05L1015.74 934.22C1016.7 937.175 1016.52 940.385 1015.22 943.209C1013.92 946.033 1011.61 948.265 1008.74 949.46C1007.25 950.039 1005.68 950.376 1004.09 950.46H1006.8L950.62 951.37H950.23C949.979 951.837 949.607 952.227 949.153 952.5C948.699 952.773 948.18 952.918 947.65 952.92C946.868 952.898 946.125 952.572 945.58 952.01C945.425 951.87 945.229 951.782 945.021 951.758C944.813 951.735 944.603 951.777 944.42 951.88C943.619 952.431 942.681 952.746 941.71 952.79C941.272 952.804 940.837 952.721 940.434 952.548C940.032 952.376 939.672 952.117 939.38 951.79C939.307 951.692 939.214 951.61 939.108 951.55C939.001 951.49 938.883 951.453 938.762 951.442C938.64 951.431 938.517 951.445 938.402 951.484C938.286 951.524 938.18 951.587 938.09 951.67C937.197 952.464 936.054 952.92 934.86 952.96C934.321 952.963 933.789 952.85 933.298 952.627C932.808 952.404 932.372 952.078 932.02 951.67C931.89 951.54 931.76 951.41 931.63 951.41H930.86C930.761 951.423 930.67 951.469 930.6 951.54C930.085 951.944 929.52 952.28 928.92 952.54C929.316 953.575 929.791 954.578 930.34 955.54C930.701 956.022 931.169 956.412 931.707 956.681C932.245 956.951 932.838 957.09 933.44 957.09C934.701 957.065 935.903 956.556 936.8 955.67C936.93 955.54 936.93 955.54 937.06 955.54H937.83C937.96 955.54 938.09 955.67 938.22 955.8C938.572 956.208 939.008 956.534 939.498 956.757C939.989 956.98 940.521 957.093 941.06 957.09C942.254 957.05 943.397 956.594 944.29 955.8C944.38 955.717 944.487 955.655 944.603 955.616C944.719 955.578 944.842 955.564 944.964 955.577C945.086 955.589 945.203 955.627 945.31 955.688C945.416 955.749 945.508 955.831 945.58 955.93C945.872 956.257 946.232 956.515 946.634 956.688C947.037 956.861 947.472 956.944 947.91 956.93C948.878 956.883 949.816 956.572 950.62 956.03C950.704 955.96 950.801 955.908 950.905 955.877C951.01 955.846 951.119 955.836 951.228 955.848C951.336 955.86 951.441 955.894 951.536 955.948C951.63 956.001 951.714 956.074 951.78 956.16C952.331 956.711 953.071 957.033 953.85 957.06C954.378 957.052 954.895 956.904 955.348 956.632C955.801 956.36 956.175 955.973 956.43 955.51H956.82L1013 954.61H1010.29C1011.89 954.589 1013.47 954.249 1014.93 953.61C1017.79 952.396 1020.09 950.157 1021.37 947.332C1022.66 944.508 1022.85 941.303 1021.89 938.35V938.35Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.54 954.11C921.637 951.398 922.547 948.778 924.152 946.59C925.757 944.402 927.982 942.747 930.54 941.84L967.61 930.47C967.931 930.346 968.275 930.293 968.619 930.312C968.962 930.331 969.298 930.423 969.603 930.582C969.909 930.741 970.177 930.963 970.39 931.233C970.603 931.504 970.757 931.816 970.84 932.15C972.26 936.8 975.74 947.01 982.72 954.15H1019.65C1020 954.128 1020.36 954.179 1020.69 954.299C1021.02 954.419 1021.33 954.605 1021.58 954.848C1021.84 955.09 1022.05 955.382 1022.19 955.707C1022.33 956.031 1022.4 956.381 1022.4 956.735C1022.4 957.089 1022.33 957.439 1022.19 957.763C1022.05 958.088 1021.84 958.38 1021.58 958.622C1021.33 958.865 1021.02 959.051 1020.69 959.171C1020.36 959.291 1020 959.342 1019.65 959.32H924C923.315 959.317 922.659 959.043 922.175 958.558C921.691 958.072 921.42 957.415 921.42 956.73V954.15L921.54 954.11Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M921.54 954.11C921.606 951.965 922.194 949.868 923.251 948C924.309 946.133 925.805 944.551 927.61 943.39C922.96 946.75 928.52 949.98 935.23 949.72C969.46 948.17 973.85 948.17 977.85 947.78C977.801 947.729 977.764 947.667 977.741 947.6C977.719 947.532 977.711 947.461 977.72 947.39C979.213 949.798 980.945 952.05 982.89 954.11H1019.82C1020.17 954.088 1020.53 954.139 1020.86 954.259C1021.19 954.379 1021.5 954.565 1021.75 954.808C1022.01 955.05 1022.22 955.342 1022.36 955.667C1022.5 955.991 1022.57 956.341 1022.57 956.695C1022.57 957.049 1022.5 957.399 1022.36 957.723C1022.22 958.048 1022.01 958.34 1021.75 958.582C1021.5 958.825 1021.19 959.011 1020.86 959.131C1020.53 959.251 1020.17 959.302 1019.82 959.28H924.12C923.435 959.277 922.779 959.003 922.295 958.518C921.812 958.032 921.54 957.375 921.54 956.69V954.11Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M921.54 953.33H982.11L982.89 954.11H921.54V953.33Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    style: {
      baselineShift: 0,
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1003.94 942.23C1005.2 942.297 1006.46 942.035 1007.6 941.469C1008.73 940.902 1009.7 940.052 1010.4 939C1011.1 937.741 1011.43 936.312 1011.36 934.875C1011.29 933.437 1010.82 932.047 1010.01 930.86C1009.94 930.74 1009.85 930.637 1009.74 930.557C1009.62 930.477 1009.5 930.423 1009.36 930.398C1009.23 930.373 1009.09 930.378 1008.95 930.413C1008.82 930.448 1008.7 930.512 1008.59 930.6C1008.47 930.666 1008.36 930.759 1008.28 930.871C1008.2 930.983 1008.15 931.112 1008.12 931.248C1008.1 931.384 1008.1 931.524 1008.14 931.658C1008.17 931.791 1008.24 931.915 1008.33 932.02C1008.95 932.849 1009.32 933.84 1009.39 934.872C1009.46 935.905 1009.22 936.936 1008.72 937.84C1007.72 939.52 1005.62 940.29 1002.9 940.03C1002.76 940.007 1002.62 940.014 1002.49 940.048C1002.35 940.082 1002.23 940.144 1002.12 940.23C1002.01 940.315 1001.92 940.423 1001.86 940.545C1001.79 940.667 1001.75 940.802 1001.74 940.94C1001.72 941.077 1001.72 941.217 1001.76 941.351C1001.79 941.485 1001.85 941.611 1001.94 941.72C1002.03 941.829 1002.13 941.919 1002.25 941.985C1002.38 942.05 1002.51 942.089 1002.65 942.1C1003 942.1 1003.42 942.23 1003.94 942.23Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1044.59 863.32L1063.84 919.5C1064.33 921.035 1064.32 922.686 1063.81 924.214C1063.3 925.742 1062.31 927.068 1061 928C1057.13 930.84 1052.22 931.23 1046.54 933.17L1006.37 946.6C1002.5 947.89 1007.02 955.38 1007.02 955.38C1007.38 955.862 1007.85 956.252 1008.39 956.521C1008.92 956.79 1009.52 956.93 1010.12 956.93C1011.38 956.897 1012.58 956.39 1013.48 955.51C1013.61 955.38 1013.61 955.38 1013.74 955.38H1014.51C1014.64 955.38 1014.77 955.51 1014.9 955.64C1015.25 956.048 1015.69 956.375 1016.18 956.598C1016.67 956.821 1017.2 956.934 1017.74 956.93C1018.93 956.888 1020.08 956.432 1020.97 955.64C1021.06 955.557 1021.17 955.495 1021.28 955.456C1021.4 955.418 1021.52 955.404 1021.64 955.417C1021.77 955.429 1021.88 955.467 1021.99 955.528C1022.1 955.589 1022.19 955.671 1022.26 955.77C1022.55 956.095 1022.91 956.353 1023.31 956.526C1023.71 956.699 1024.14 956.782 1024.58 956.77C1025.55 956.725 1026.49 956.414 1027.3 955.87C1027.5 955.735 1027.73 955.674 1027.97 955.698C1028.21 955.721 1028.43 955.829 1028.59 956C1028.93 956.305 1029.33 956.531 1029.76 956.659C1030.2 956.786 1030.66 956.814 1031.1 956.739C1031.55 956.664 1031.98 956.488 1032.35 956.225C1032.72 955.962 1033.02 955.618 1033.24 955.22H1033.63L1089.8 954.32H1087.09C1088.69 954.3 1090.27 953.96 1091.74 953.32C1097.68 951 1100.65 944.32 1098.85 938.08L1094.71 924.91L1084.9 861.63L1044.59 863.32Z",
    fill: "#956363",
    style: {
      baselineShift: 0,
      fill: "rgb(149, 99, 99)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1098.45 938.35L1094.31 925.18L1084.5 861.9L1045.11 863.45L1059.11 866.8C1063.18 867.799 1066.93 869.835 1069.99 872.711C1073.04 875.586 1075.3 879.203 1076.54 883.21L1088.17 921.05L1092.3 934.22C1093.26 937.175 1093.07 940.384 1091.78 943.207C1090.48 946.031 1088.17 948.263 1085.3 949.46C1083.82 950.039 1082.25 950.376 1080.66 950.46H1083.37L1027.19 951.37H1026.8C1026.54 951.833 1026.17 952.22 1025.72 952.492C1025.27 952.764 1024.75 952.912 1024.22 952.92C1023.44 952.898 1022.7 952.572 1022.15 952.01C1021.99 951.87 1021.8 951.782 1021.59 951.758C1021.38 951.735 1021.17 951.777 1020.99 951.88C1020.19 952.429 1019.25 952.744 1018.28 952.79C1017.84 952.804 1017.41 952.721 1017 952.548C1016.6 952.376 1016.24 952.117 1015.95 951.79C1015.88 951.692 1015.78 951.61 1015.68 951.55C1015.57 951.49 1015.45 951.453 1015.33 951.442C1015.21 951.431 1015.09 951.445 1014.97 951.484C1014.86 951.524 1014.75 951.587 1014.66 951.67C1013.77 952.462 1012.62 952.918 1011.43 952.96C1010.89 952.963 1010.36 952.85 1009.87 952.627C1009.38 952.404 1008.94 952.078 1008.59 951.67C1008.46 951.54 1008.33 951.41 1008.2 951.41H1007.43C1007.33 951.423 1007.24 951.469 1007.17 951.54C1006.66 951.944 1006.09 952.28 1005.49 952.54C1005.89 953.575 1006.36 954.578 1006.91 955.54C1007.27 956.022 1007.74 956.412 1008.28 956.681C1008.82 956.951 1009.41 957.09 1010.01 957.09C1011.27 957.057 1012.47 956.55 1013.37 955.67C1013.5 955.54 1013.5 955.54 1013.63 955.54H1014.4C1014.53 955.54 1014.66 955.67 1014.79 955.8C1015.14 956.208 1015.58 956.534 1016.07 956.757C1016.56 956.98 1017.09 957.093 1017.63 957.09C1018.82 957.05 1019.97 956.594 1020.86 955.8C1020.95 955.717 1021.06 955.655 1021.17 955.616C1021.29 955.578 1021.41 955.564 1021.53 955.577C1021.66 955.589 1021.77 955.627 1021.88 955.688C1021.99 955.749 1022.08 955.831 1022.15 955.93C1022.44 956.257 1022.8 956.515 1023.2 956.688C1023.61 956.861 1024.04 956.944 1024.48 956.93C1025.45 956.883 1026.39 956.572 1027.19 956.03C1027.27 955.96 1027.37 955.908 1027.48 955.877C1027.58 955.846 1027.69 955.836 1027.8 955.848C1027.91 955.86 1028.01 955.894 1028.11 955.948C1028.2 956.001 1028.28 956.074 1028.35 956.16C1028.9 956.711 1029.64 957.033 1030.42 957.06C1030.95 957.052 1031.47 956.904 1031.92 956.632C1032.37 956.36 1032.74 955.973 1033 955.51H1033.39L1089.57 954.61H1086.85C1088.45 954.59 1090.03 954.25 1091.5 953.61C1094.35 952.391 1096.65 950.15 1097.93 947.327C1099.22 944.504 1099.4 941.302 1098.45 938.35V938.35Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.1 954.11C998.194 951.397 999.103 948.776 1000.71 946.587C1002.31 944.399 1004.54 942.745 1007.1 941.84L1044.17 930.47C1044.49 930.346 1044.83 930.293 1045.18 930.312C1045.52 930.332 1045.86 930.424 1046.16 930.583C1046.46 930.742 1046.73 930.964 1046.94 931.234C1047.16 931.504 1047.31 931.816 1047.39 932.15C1048.81 936.8 1052.3 947.01 1059.28 954.15H1096.21C1096.56 954.128 1096.92 954.179 1097.25 954.299C1097.58 954.419 1097.89 954.605 1098.14 954.848C1098.4 955.09 1098.61 955.382 1098.75 955.707C1098.89 956.031 1098.96 956.381 1098.96 956.735C1098.96 957.089 1098.89 957.439 1098.75 957.763C1098.61 958.088 1098.4 958.38 1098.14 958.622C1097.89 958.865 1097.58 959.052 1097.25 959.171C1096.92 959.291 1096.56 959.342 1096.21 959.32H1000.51C999.825 959.317 999.169 959.043 998.685 958.558C998.202 958.072 997.93 957.415 997.93 956.73V954.15L998.1 954.11Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M998.1 954.11C998.166 951.965 998.754 949.868 999.811 948C1000.87 946.133 1002.36 944.551 1004.17 943.39C999.52 946.75 1005.07 949.98 1011.79 949.72C1046.01 948.17 1050.4 948.17 1054.41 947.78C1054.36 947.729 1054.32 947.667 1054.3 947.6C1054.28 947.532 1054.27 947.461 1054.28 947.39C1055.77 949.796 1057.5 952.047 1059.44 954.11H1096.38C1097.04 954.151 1097.66 954.441 1098.11 954.921C1098.56 955.402 1098.81 956.036 1098.81 956.695C1098.81 957.354 1098.56 957.988 1098.11 958.469C1097.66 958.949 1097.04 959.239 1096.38 959.28H1000.68C999.995 959.277 999.339 959.003 998.855 958.518C998.372 958.032 998.1 957.375 998.1 956.69V954.11Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M998.1 953.33H1058.67L1059.44 954.11H998.1V953.33Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    style: {
      baselineShift: 0,
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1080.5 942.23C1081.77 942.307 1083.04 942.05 1084.18 941.483C1085.32 940.916 1086.29 940.06 1087 939C1087.7 937.741 1088.03 936.313 1087.96 934.876C1087.9 933.439 1087.43 932.049 1086.62 930.86C1086.55 930.74 1086.46 930.637 1086.35 930.557C1086.23 930.477 1086.11 930.423 1085.97 930.398C1085.84 930.373 1085.7 930.378 1085.56 930.413C1085.43 930.448 1085.31 930.512 1085.2 930.6C1085.08 930.666 1084.97 930.759 1084.89 930.871C1084.81 930.983 1084.76 931.112 1084.73 931.248C1084.71 931.384 1084.71 931.524 1084.75 931.658C1084.78 931.791 1084.85 931.915 1084.94 932.02C1085.56 932.849 1085.93 933.84 1085.99 934.874C1086.06 935.907 1085.83 936.938 1085.32 937.84C1084.32 939.52 1082.23 940.29 1079.51 940.03C1079.37 940.007 1079.23 940.014 1079.1 940.048C1078.96 940.082 1078.84 940.144 1078.73 940.23C1078.62 940.315 1078.53 940.423 1078.47 940.545C1078.4 940.667 1078.36 940.802 1078.35 940.94C1078.33 941.076 1078.33 941.215 1078.37 941.349C1078.4 941.483 1078.46 941.608 1078.55 941.717C1078.63 941.826 1078.74 941.916 1078.86 941.982C1078.98 942.048 1079.11 942.088 1079.25 942.1C1079.59 942.1 1080 942.23 1080.5 942.23Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1176.52 704.85V738.67C1176.52 746.91 1173.25 754.813 1167.42 760.64C1161.59 766.467 1153.69 769.74 1145.45 769.74H994.25C1008.17 799.96 1010.73 845.81 1018.42 896.91C1018.42 897.16 1018.49 897.41 1018.53 897.65H975.47L926.67 746.22C925.087 741.347 924.684 736.168 925.495 731.11C926.307 726.051 928.309 721.257 931.336 717.124C934.364 712.991 938.33 709.637 942.909 707.337C947.487 705.038 952.547 703.86 957.67 703.9L1176.52 704.85Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1133.88 727V703.9H1019.44C1014.97 703.901 1010.58 705.121 1006.75 707.429C1002.93 709.738 999.798 713.047 997.71 717V717C996.098 720.029 993.69 722.561 990.746 724.323C987.801 726.086 984.432 727.011 981 727H967.33C965.502 727.001 963.699 727.43 962.067 728.254C960.435 729.078 959.019 730.273 957.933 731.744C956.847 733.214 956.12 734.919 955.813 736.721C955.505 738.523 955.624 740.372 956.16 742.12L1003.87 897.63H1017.12L1018.42 896.89C1010.73 845.79 1008.17 799.94 994.25 769.72H1145.45C1149.53 769.72 1153.57 768.916 1157.34 767.355C1161.11 765.794 1164.53 763.505 1167.42 760.62C1170.3 757.735 1172.59 754.31 1174.15 750.54C1175.72 746.77 1176.52 742.73 1176.52 738.65V727H1133.88Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.29 704.85V738.67C1252.29 746.908 1249.02 754.81 1243.19 760.636C1237.37 766.463 1229.47 769.737 1221.23 769.74H1070C1084 800.11 1086.5 846.26 1094.28 897.65H1051.21L1002.41 746.22C1000.84 741.348 1000.44 736.172 1001.26 731.118C1002.08 726.064 1004.08 721.275 1007.1 717.145C1010.13 713.015 1014.09 709.661 1018.66 707.359C1023.24 705.056 1028.29 703.871 1033.41 703.9L1252.29 704.85Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1252.29 727V738.65C1252.29 746.889 1249.02 754.79 1243.19 760.616C1237.37 766.443 1229.47 769.717 1221.23 769.72H1070C1084 800.09 1086.5 846.24 1094.28 897.63H1080.51L1034.9 747.24C1034.19 744.898 1034.03 742.421 1034.45 740.009C1034.87 737.597 1035.85 735.316 1037.3 733.35C1038.76 731.384 1040.66 729.787 1042.85 728.688C1045.04 727.588 1047.45 727.017 1049.9 727.02L1252.29 727Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1287 592.71L1274.3 674C1274.13 675.3 1264.3 691.58 1251.61 704.23H1094.33L1131.75 576.31C1133.35 570.038 1136.89 564.436 1141.88 560.31C1145.44 557.376 1149.61 555.278 1154.09 554.17L1174.27 549.32L1232.99 551.23L1263.99 558.59C1271.41 560.349 1277.9 564.835 1282.16 571.156C1286.42 577.478 1288.15 585.172 1287 592.71V592.71Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1142.14 691L1142.31 690.83L1142.4 690.91L1142.14 691Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1142.31 582.23L1120.31 651.69L1120.22 667.63L1127.53 705.3L1145.34 638.61C1145.63 637.025 1145.32 635.39 1144.47 634.02L1140.4 627.27C1135.81 619.13 1134.86 610.9 1137.4 602.58L1143.73 582.49C1144 581.63 1142.57 581.37 1142.31 582.23Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1181.29 500.91L1179.82 545.34C1179.79 546.128 1179.5 546.885 1179 547.493C1178.5 548.102 1177.81 548.529 1177.04 548.71L1174.19 549.41L1173 567.74C1172.9 569.284 1173.1 570.834 1173.6 572.3C1174.09 573.765 1174.87 575.118 1175.9 576.28C1176.92 577.442 1178.16 578.39 1179.55 579.07C1180.94 579.75 1182.45 580.147 1184 580.24L1198.93 581.1C1202.13 581.283 1205.34 580.685 1208.26 579.358C1211.18 578.03 1213.74 576.013 1215.71 573.48L1232.93 551.31L1220.28 548.54C1219.52 548.364 1218.85 547.949 1218.35 547.356C1217.85 546.763 1217.55 546.024 1217.51 545.25L1215.26 504.89L1181.29 500.91Z",
    fill: "#956363",
    style: {
      baselineShift: 0,
      fill: "rgb(149, 99, 99)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167 512.25L1166 481.85C1165.95 480.519 1166.16 479.19 1166.63 477.942C1167.09 476.693 1167.8 475.548 1168.71 474.574C1169.62 473.6 1170.71 472.815 1171.92 472.266C1173.14 471.716 1174.45 471.411 1175.78 471.37L1206.36 470.37C1207.38 470.337 1208.4 470.505 1209.35 470.866C1210.31 471.227 1211.18 471.773 1211.92 472.473C1212.67 473.172 1213.27 474.012 1213.68 474.943C1214.1 475.875 1214.33 476.88 1214.36 477.9L1215.49 510.64C1215.7 516.821 1213.45 522.834 1209.24 527.358C1205.02 531.883 1199.18 534.548 1193 534.77L1191.18 534.86C1188.11 534.969 1185.04 534.471 1182.16 533.393C1179.28 532.315 1176.64 530.678 1174.39 528.577C1172.15 526.477 1170.34 523.953 1169.07 521.151C1167.8 518.349 1167.1 515.324 1167 512.25Z",
    fill: "#956363",
    style: {
      baselineShift: 0,
      fill: "rgb(149, 99, 99)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1194.37 502C1194.37 501.501 1194.23 501.013 1193.95 500.597C1193.67 500.182 1193.28 499.857 1192.82 499.665C1192.36 499.472 1191.85 499.421 1191.36 499.517C1190.88 499.613 1190.43 499.853 1190.07 500.205C1189.72 500.557 1189.48 501.006 1189.38 501.495C1189.28 501.984 1189.33 502.491 1189.52 502.952C1189.71 503.413 1190.03 503.807 1190.45 504.085C1190.86 504.362 1191.35 504.51 1191.85 504.51C1192.52 504.51 1193.16 504.246 1193.63 503.775C1194.1 503.305 1194.37 502.667 1194.37 502V502Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1191.42 503.16C1191.42 503.057 1191.39 502.957 1191.33 502.871C1191.28 502.786 1191.19 502.719 1191.1 502.68C1191 502.64 1190.9 502.63 1190.8 502.65C1190.7 502.67 1190.6 502.72 1190.53 502.792C1190.46 502.865 1190.41 502.958 1190.39 503.059C1190.37 503.159 1190.38 503.264 1190.42 503.359C1190.46 503.454 1190.53 503.535 1190.61 503.592C1190.7 503.65 1190.8 503.68 1190.9 503.68C1191.04 503.68 1191.17 503.625 1191.27 503.528C1191.37 503.43 1191.42 503.298 1191.42 503.16V503.16Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.88 503.85C1174.88 503.354 1174.73 502.868 1174.46 502.456C1174.18 502.043 1173.79 501.721 1173.33 501.531C1172.87 501.341 1172.37 501.291 1171.88 501.388C1171.39 501.485 1170.95 501.724 1170.6 502.075C1170.24 502.426 1170 502.873 1169.91 503.36C1169.81 503.847 1169.86 504.352 1170.05 504.811C1170.24 505.269 1170.56 505.661 1170.98 505.937C1171.39 506.213 1171.87 506.36 1172.37 506.36C1173.04 506.36 1173.67 506.096 1174.14 505.625C1174.62 505.154 1174.88 504.516 1174.88 503.85Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.76 504.89C1171.76 504.787 1171.73 504.687 1171.67 504.601C1171.61 504.516 1171.53 504.449 1171.44 504.41C1171.34 504.37 1171.24 504.36 1171.14 504.38C1171.04 504.4 1170.94 504.45 1170.87 504.522C1170.8 504.595 1170.75 504.688 1170.73 504.789C1170.71 504.889 1170.72 504.994 1170.76 505.089C1170.8 505.184 1170.87 505.265 1170.95 505.322C1171.04 505.379 1171.14 505.41 1171.24 505.41C1171.38 505.41 1171.51 505.355 1171.61 505.258C1171.7 505.16 1171.76 505.028 1171.76 504.89V504.89Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1229.15 483.68L1228.15 484.2C1227.49 487.578 1226.63 490.917 1225.6 494.2C1224.68 497.2 1223.77 499.96 1223.13 502.38C1222.8 503.69 1220.9 500.92 1219.13 498.49C1218.8 498.04 1218.47 497.61 1218.13 497.22C1217.65 496.515 1217.04 495.914 1216.32 495.45C1216.21 495.45 1215.89 495.82 1215.48 496.45L1215.4 496.57C1215.29 496.73 1215.18 496.89 1215.07 497.07C1214.59 497.81 1214.07 498.68 1213.63 499.38C1213.5 499.601 1213.31 499.783 1213.09 499.906C1212.86 500.03 1212.61 500.09 1212.35 500.081C1212.09 500.071 1211.84 499.993 1211.63 499.854C1211.41 499.715 1211.23 499.52 1211.12 499.29C1209.56 495.278 1208.68 491.032 1208.53 486.73L1208.35 482.84C1201.88 482.44 1198.08 477.84 1196.61 475.64C1196.34 475.256 1196.1 474.856 1195.88 474.44L1195.79 474.54C1188.15 484.39 1174.13 484.47 1168.35 484.04C1167.89 484 1167.44 484.099 1167.04 484.324C1166.64 484.549 1166.32 484.889 1166.12 485.3C1165.96 485.636 1165.89 486.009 1165.92 486.38L1166.2 494.22V495.6L1166.39 501.02C1165.24 499.978 1164.18 498.844 1163.21 497.63C1162.94 497.3 1162.66 496.95 1162.38 496.57L1161.71 495.64L1159.05 497.86L1158.97 497.93C1159.1 497.397 1159.2 496.856 1159.26 496.31V496.26C1159.32 495.378 1159.32 494.492 1159.26 493.61V493.61C1159.26 493.42 1159.26 493.21 1159.26 493.02V492.97C1159.26 492.001 1159.11 491.039 1158.8 490.12C1158.75 490.029 1158.71 489.936 1158.68 489.84V489.84C1158.42 489.22 1158.19 488.58 1157.98 487.92C1157.54 486.472 1157.23 484.985 1157.07 483.48C1156.3 475.69 1160.28 472.39 1162.45 471.18C1162.82 470.958 1163.13 470.642 1163.35 470.263C1163.56 469.883 1163.67 469.455 1163.66 469.02C1163.4 444.59 1196.22 436.28 1214.75 449.44C1225.92 457.44 1229.13 466.94 1228.96 476.21C1228.95 476.386 1228.95 476.563 1228.96 476.74V476.74C1228.89 479.055 1228.96 481.372 1229.15 483.68V483.68Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.62 698.11L1187.44 702.01C1182.93 702.62 1178.6 703.31 1174.36 701.84L1169.16 700.02C1168.53 699.795 1167.85 699.708 1167.18 699.767C1166.51 699.826 1165.86 700.028 1165.27 700.36L1153.14 707.36C1152.84 707.536 1152.49 707.628 1152.14 707.628C1151.79 707.628 1151.44 707.536 1151.14 707.36C1150.85 707.214 1150.59 706.998 1150.4 706.731C1150.21 706.464 1150.09 706.154 1150.05 705.829C1150.01 705.504 1150.05 705.174 1150.16 704.867C1150.28 704.561 1150.46 704.287 1150.71 704.07L1159.37 695.84L1146.64 708C1146.37 708.285 1146.02 708.492 1145.64 708.597C1145.26 708.703 1144.86 708.704 1144.48 708.6C1144.1 708.5 1143.76 708.308 1143.48 708.04C1143.19 707.773 1142.98 707.439 1142.86 707.069C1142.74 706.699 1142.72 706.305 1142.79 705.923C1142.86 705.54 1143.03 705.182 1143.27 704.88L1152.1 693.71L1140.5 708.34C1140.22 708.722 1139.82 709.01 1139.37 709.165C1138.93 709.32 1138.44 709.336 1137.98 709.21C1136.34 708.86 1136.6 707.21 1137.55 705.74L1145.95 693.1L1130.88 705.57C1129.88 706.57 1129.06 707.04 1128.02 706.09C1126.98 705.14 1127.33 703.93 1128.2 702.89L1140.67 690.5C1142.57 688.34 1143.87 687.56 1146.56 687.38L1172.11 686.52L1219.22 675.52L1227.62 698.11Z",
    fill: "#956363",
    style: {
      baselineShift: 0,
      fill: "rgb(149, 99, 99)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1165.27 700.28C1165.86 699.946 1166.51 699.742 1167.18 699.682C1167.85 699.621 1168.52 699.706 1169.16 699.93L1174.36 701.75C1178.6 703.14 1183.02 702.53 1187.44 701.92L1213.44 699.41L1206.34 678.19L1206.08 694.82L1179.12 699C1174.62 699.6 1170.29 700.3 1166.04 698.83L1165.27 700.28Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1150.54 704.43C1150.5 704.391 1150.47 704.344 1150.45 704.293C1150.43 704.241 1150.41 704.186 1150.41 704.13C1150.41 704.074 1150.43 704.019 1150.45 703.967C1150.47 703.916 1150.5 703.869 1150.54 703.83L1158.54 696.29C1158.62 696.209 1158.73 696.164 1158.85 696.164C1158.96 696.164 1159.07 696.209 1159.15 696.29C1159.23 696.371 1159.28 696.481 1159.28 696.595C1159.28 696.709 1159.23 696.819 1159.15 696.9L1151.15 704.43C1151.06 704.43 1150.97 704.52 1150.89 704.52C1150.81 704.52 1150.63 704.43 1150.54 704.43Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1143 705.21C1142.95 705.177 1142.91 705.136 1142.88 705.087C1142.86 705.039 1142.84 704.985 1142.83 704.929C1142.82 704.873 1142.82 704.816 1142.84 704.761C1142.85 704.706 1142.88 704.655 1142.91 704.61L1151.22 694.13C1151.4 693.96 1151.66 693.87 1151.83 694.04C1152 694.21 1152.09 694.47 1151.92 694.65L1143.6 705.13C1143.52 705.21 1143.43 705.3 1143.34 705.3C1143.25 705.3 1143.09 705.21 1143 705.21Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1166.56 698.81L1169.25 699.93C1168.61 699.706 1167.93 699.621 1167.26 699.681C1166.59 699.742 1165.94 699.946 1165.35 700.28L1153.23 707.28C1152.93 707.456 1152.58 707.548 1152.23 707.548C1151.88 707.548 1151.53 707.456 1151.23 707.28C1150.88 707.068 1150.6 706.758 1150.42 706.389C1150.24 706.019 1150.18 705.606 1150.23 705.2C1150.31 705.29 1151.23 706.94 1153.43 705.29C1154.99 704.17 1159.67 701.05 1162.35 699.23C1162.98 698.85 1163.68 698.615 1164.41 698.542C1165.14 698.469 1165.87 698.561 1166.56 698.81V698.81Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.51 699.41L1256.12 695.6C1267.46 694.13 1272.57 684.43 1274.39 673L1238.53 670.4L1206.32 678.19L1213.51 699.41Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1211.43 693.52L1213.43 699.52L1256.04 695.71C1267.04 694.32 1272.15 685.14 1274.14 674.23V674.14L1286.79 592.9C1287.94 585.364 1286.21 577.672 1281.95 571.351C1277.69 565.03 1271.21 560.543 1263.79 558.78L1260.33 557.92C1266.77 560.557 1272.16 565.267 1275.62 571.305C1279.09 577.344 1280.44 584.366 1279.47 591.26L1266.83 672.5C1264.05 680.81 1259.64 688.78 1250.28 689.99L1211.43 693.52Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1193.24 680.88C1193.23 680.969 1193.25 681.057 1193.28 681.14C1193.32 681.222 1193.37 681.295 1193.43 681.353C1193.5 681.412 1193.58 681.453 1193.67 681.475C1193.75 681.497 1193.84 681.499 1193.93 681.48L1238.62 670.48L1250.49 590.98C1250.49 590.813 1250.43 590.651 1250.32 590.522C1250.22 590.394 1250.07 590.307 1249.9 590.276C1249.74 590.245 1249.57 590.273 1249.42 590.354C1249.28 590.435 1249.16 590.564 1249.1 590.72L1226.93 671.72L1193.76 680.2C1193.68 680.196 1193.59 680.212 1193.52 680.248C1193.44 680.283 1193.37 680.337 1193.32 680.404C1193.27 680.47 1193.24 680.549 1193.22 680.632C1193.21 680.715 1193.21 680.8 1193.24 680.88V680.88Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1216.1 519.53L1212.38 512.08H1215.5L1216.1 519.53Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M1180 540.31C1181.66 540.54 1183.33 540.6 1185 540.49C1189.25 540.199 1193.27 538.491 1196.43 535.64C1200.02 535.018 1203.43 533.63 1206.43 531.57C1206.5 531.527 1206.56 531.47 1206.61 531.402C1206.66 531.334 1206.7 531.257 1206.71 531.175C1206.73 531.093 1206.73 531.008 1206.71 530.927C1206.69 530.845 1206.66 530.768 1206.61 530.7C1206.57 530.628 1206.51 530.565 1206.44 530.516C1206.37 530.468 1206.3 530.434 1206.21 530.418C1206.13 530.402 1206.05 530.404 1205.96 530.423C1205.88 530.442 1205.81 530.479 1205.74 530.53C1203.41 532.097 1200.83 533.266 1198.12 533.99C1197.95 534.08 1197.69 534.08 1197.51 534.16C1197 534.319 1196.48 534.436 1195.95 534.51H1195.69C1195.35 534.6 1195 534.6 1194.69 534.68C1193.8 534.785 1192.91 534.845 1192.01 534.86C1187.99 535.095 1183.97 534.321 1180.32 532.61L1180 540.31Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.35,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154 649.1L1153.5 648.6C1153.81 648.302 1154.05 647.944 1154.22 647.549C1154.39 647.154 1154.48 646.729 1154.48 646.3C1154.48 645.871 1154.39 645.446 1154.22 645.051C1154.05 644.656 1153.81 644.298 1153.5 644L1154 643.5C1154.3 643.808 1154.66 644.054 1155.05 644.221C1155.45 644.389 1155.87 644.475 1156.3 644.475C1156.73 644.475 1157.15 644.389 1157.55 644.221C1157.94 644.054 1158.3 643.808 1158.6 643.5L1159.1 644C1158.79 644.298 1158.55 644.656 1158.38 645.051C1158.21 645.446 1158.12 645.871 1158.12 646.3C1158.12 646.729 1158.21 647.154 1158.38 647.549C1158.55 647.944 1158.79 648.302 1159.1 648.6L1158.6 649.1C1158.3 648.792 1157.94 648.546 1157.55 648.379C1157.15 648.211 1156.73 648.125 1156.3 648.125C1155.87 648.125 1155.45 648.211 1155.05 648.379C1154.66 648.546 1154.3 648.792 1154 649.1V649.1Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1162.93 584.26L1162.43 583.76C1162.74 583.462 1162.98 583.104 1163.15 582.709C1163.32 582.314 1163.41 581.889 1163.41 581.46C1163.41 581.031 1163.32 580.606 1163.15 580.211C1162.98 579.816 1162.74 579.458 1162.43 579.16L1162.93 578.66C1163.23 578.968 1163.59 579.214 1163.98 579.381C1164.38 579.549 1164.8 579.635 1165.23 579.635C1165.66 579.635 1166.08 579.549 1166.48 579.381C1166.87 579.214 1167.23 578.968 1167.53 578.66L1168.03 579.16C1167.72 579.458 1167.48 579.816 1167.31 580.211C1167.14 580.606 1167.05 581.031 1167.05 581.46C1167.05 581.889 1167.14 582.314 1167.31 582.709C1167.48 583.104 1167.72 583.462 1168.03 583.76L1167.53 584.26C1167.23 583.952 1166.87 583.706 1166.48 583.539C1166.08 583.371 1165.66 583.285 1165.23 583.285C1164.8 583.285 1164.38 583.371 1163.98 583.539C1163.59 583.706 1163.23 583.952 1162.93 584.26Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.14 565.17L1141.64 565.67C1141.34 565.362 1140.98 565.116 1140.59 564.949C1140.19 564.781 1139.77 564.695 1139.34 564.695C1138.91 564.695 1138.49 564.781 1138.09 564.949C1137.7 565.116 1137.34 565.362 1137.04 565.67L1136.9 565.53C1138.35 563.597 1140.03 561.845 1141.9 560.31L1142.16 560.57C1141.85 560.867 1141.6 561.223 1141.43 561.618C1141.26 562.012 1141.18 562.437 1141.17 562.866C1141.17 563.295 1141.26 563.72 1141.42 564.116C1141.59 564.512 1141.83 564.87 1142.14 565.17V565.17Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.25 563.5L1234.75 563C1235.06 562.702 1235.3 562.344 1235.47 561.949C1235.64 561.554 1235.73 561.129 1235.73 560.7C1235.73 560.271 1235.64 559.846 1235.47 559.451C1235.3 559.056 1235.06 558.698 1234.75 558.4L1235.25 557.9C1235.55 558.208 1235.91 558.454 1236.3 558.621C1236.7 558.789 1237.12 558.875 1237.55 558.875C1237.98 558.875 1238.4 558.789 1238.8 558.621C1239.19 558.454 1239.55 558.208 1239.85 557.9L1240.35 558.4C1240.04 558.698 1239.8 559.056 1239.63 559.451C1239.46 559.846 1239.37 560.271 1239.37 560.7C1239.37 561.129 1239.46 561.554 1239.63 561.949C1239.8 562.344 1240.04 562.702 1240.35 563L1239.85 563.5C1239.55 563.192 1239.19 562.946 1238.8 562.779C1238.4 562.611 1237.98 562.525 1237.55 562.525C1237.12 562.525 1236.7 562.611 1236.3 562.779C1235.91 562.946 1235.55 563.192 1235.25 563.5V563.5Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1267.33 584.5L1266.83 584C1267.14 583.702 1267.38 583.344 1267.55 582.949C1267.72 582.554 1267.81 582.129 1267.81 581.7C1267.81 581.271 1267.72 580.846 1267.55 580.451C1267.38 580.056 1267.14 579.698 1266.83 579.4L1267.33 578.9C1267.63 579.208 1267.99 579.454 1268.38 579.621C1268.78 579.789 1269.2 579.875 1269.63 579.875C1270.06 579.875 1270.48 579.789 1270.88 579.621C1271.27 579.454 1271.63 579.208 1271.93 578.9L1272.43 579.4C1272.12 579.698 1271.88 580.056 1271.71 580.451C1271.54 580.846 1271.45 581.271 1271.45 581.7C1271.45 582.129 1271.54 582.554 1271.71 582.949C1271.88 583.344 1272.12 583.702 1272.43 584L1271.93 584.5C1271.63 584.192 1271.27 583.946 1270.88 583.779C1270.48 583.611 1270.06 583.525 1269.63 583.525C1269.2 583.525 1268.78 583.611 1268.38 583.779C1267.99 583.946 1267.63 584.192 1267.33 584.5V584.5Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247 682.71L1246.5 682.21C1246.81 681.912 1247.05 681.554 1247.22 681.159C1247.39 680.764 1247.48 680.339 1247.48 679.91C1247.48 679.481 1247.39 679.056 1247.22 678.661C1247.05 678.266 1246.81 677.908 1246.5 677.61L1247 677.11C1247.3 677.418 1247.66 677.664 1248.05 677.831C1248.45 677.999 1248.87 678.085 1249.3 678.085C1249.73 678.085 1250.15 677.999 1250.55 677.831C1250.94 677.664 1251.3 677.418 1251.6 677.11L1252.1 677.61C1251.79 677.908 1251.55 678.266 1251.38 678.661C1251.21 679.056 1251.12 679.481 1251.12 679.91C1251.12 680.339 1251.21 680.764 1251.38 681.159C1251.55 681.554 1251.79 681.912 1252.1 682.21L1251.6 682.71C1251.3 682.402 1250.94 682.156 1250.55 681.989C1250.15 681.821 1249.73 681.735 1249.3 681.735C1248.87 681.735 1248.45 681.821 1248.05 681.989C1247.66 682.156 1247.3 682.402 1247 682.71V682.71Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179.13 624.26L1178.63 623.76C1178.94 623.462 1179.18 623.104 1179.35 622.709C1179.52 622.314 1179.6 621.889 1179.6 621.46C1179.6 621.031 1179.52 620.606 1179.35 620.211C1179.18 619.816 1178.94 619.458 1178.63 619.16L1179.13 618.66C1179.43 618.968 1179.79 619.214 1180.18 619.381C1180.58 619.549 1181 619.635 1181.43 619.635C1181.86 619.635 1182.28 619.549 1182.68 619.381C1183.07 619.214 1183.43 618.968 1183.73 618.66L1184.23 619.16C1183.92 619.458 1183.68 619.816 1183.51 620.211C1183.34 620.606 1183.25 621.031 1183.25 621.46C1183.25 621.889 1183.34 622.314 1183.51 622.709C1183.68 623.104 1183.92 623.462 1184.23 623.76L1183.73 624.26C1183.43 623.952 1183.07 623.706 1182.68 623.539C1182.28 623.371 1181.86 623.285 1181.43 623.285C1181 623.285 1180.58 623.371 1180.18 623.539C1179.79 623.706 1179.43 623.952 1179.13 624.26Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.5 685.51L1158 685.01C1158.31 684.712 1158.55 684.354 1158.72 683.959C1158.89 683.564 1158.98 683.139 1158.98 682.71C1158.98 682.281 1158.89 681.856 1158.72 681.461C1158.55 681.066 1158.31 680.708 1158 680.41L1158.5 679.91C1158.8 680.218 1159.16 680.464 1159.55 680.631C1159.95 680.799 1160.37 680.885 1160.8 680.885C1161.23 680.885 1161.65 680.799 1162.05 680.631C1162.44 680.464 1162.8 680.218 1163.1 679.91L1163.6 680.41C1163.29 680.708 1163.05 681.066 1162.88 681.461C1162.71 681.856 1162.62 682.281 1162.62 682.71C1162.62 683.139 1162.71 683.564 1162.88 683.959C1163.05 684.354 1163.29 684.712 1163.6 685.01L1163.1 685.51C1162.8 685.202 1162.44 684.956 1162.05 684.789C1161.65 684.621 1161.23 684.535 1160.8 684.535C1160.37 684.535 1159.95 684.621 1159.55 684.789C1159.16 684.956 1158.8 685.202 1158.5 685.51Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1219.09 606.66L1218.59 606.16C1218.9 605.862 1219.14 605.504 1219.31 605.109C1219.48 604.714 1219.57 604.289 1219.57 603.86C1219.57 603.431 1219.48 603.006 1219.31 602.611C1219.14 602.216 1218.9 601.858 1218.59 601.56L1219.09 601.06C1219.39 601.368 1219.75 601.614 1220.14 601.781C1220.54 601.949 1220.96 602.035 1221.39 602.035C1221.82 602.035 1222.24 601.949 1222.64 601.781C1223.03 601.614 1223.39 601.368 1223.69 601.06L1224.19 601.56C1223.88 601.858 1223.64 602.216 1223.47 602.611C1223.3 603.006 1223.21 603.431 1223.21 603.86C1223.21 604.289 1223.3 604.714 1223.47 605.109C1223.64 605.504 1223.88 605.862 1224.19 606.16L1223.69 606.66C1223.39 606.352 1223.03 606.106 1222.64 605.939C1222.24 605.771 1221.82 605.685 1221.39 605.685C1220.96 605.685 1220.54 605.771 1220.14 605.939C1219.75 606.106 1219.39 606.352 1219.09 606.66V606.66Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1198.9 660.66L1198.4 660.16C1198.71 659.862 1198.95 659.504 1199.12 659.109C1199.29 658.714 1199.38 658.289 1199.38 657.86C1199.38 657.431 1199.29 657.006 1199.12 656.611C1198.95 656.216 1198.71 655.858 1198.4 655.56L1198.9 655.06C1199.2 655.368 1199.56 655.614 1199.95 655.781C1200.35 655.949 1200.77 656.035 1201.2 656.035C1201.63 656.035 1202.05 655.949 1202.45 655.781C1202.84 655.614 1203.2 655.368 1203.5 655.06L1204 655.56C1203.69 655.858 1203.45 656.216 1203.28 656.611C1203.11 657.006 1203.02 657.431 1203.02 657.86C1203.02 658.289 1203.11 658.714 1203.28 659.109C1203.45 659.504 1203.69 659.862 1204 660.16L1203.5 660.66C1203.2 660.352 1202.84 660.106 1202.45 659.939C1202.05 659.771 1201.63 659.685 1201.2 659.685C1200.77 659.685 1200.35 659.771 1199.95 659.939C1199.56 660.106 1199.2 660.352 1198.9 660.66V660.66Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.61 647.25L1230.11 646.75C1230.42 646.452 1230.66 646.094 1230.83 645.699C1231 645.304 1231.08 644.879 1231.08 644.45C1231.08 644.021 1231 643.596 1230.83 643.201C1230.66 642.806 1230.42 642.448 1230.11 642.15L1230.61 641.65C1230.91 641.958 1231.27 642.204 1231.66 642.371C1232.06 642.539 1232.48 642.625 1232.91 642.625C1233.34 642.625 1233.76 642.539 1234.16 642.371C1234.55 642.204 1234.91 641.958 1235.21 641.65L1235.71 642.15C1235.4 642.448 1235.16 642.806 1234.99 643.201C1234.82 643.596 1234.73 644.021 1234.73 644.45C1234.73 644.879 1234.82 645.304 1234.99 645.699C1235.16 646.094 1235.4 646.452 1235.71 646.75L1235.21 647.25C1234.91 646.942 1234.55 646.696 1234.16 646.529C1233.76 646.361 1233.34 646.275 1232.91 646.275C1232.48 646.275 1232.06 646.361 1231.66 646.529C1231.27 646.696 1230.91 646.942 1230.61 647.25Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.72 622.61L1260.22 622.11C1260.53 621.812 1260.77 621.454 1260.94 621.059C1261.11 620.664 1261.19 620.239 1261.19 619.81C1261.19 619.381 1261.11 618.956 1260.94 618.561C1260.77 618.166 1260.53 617.808 1260.22 617.51L1260.72 617.01C1261.02 617.318 1261.38 617.564 1261.77 617.731C1262.17 617.899 1262.59 617.985 1263.02 617.985C1263.45 617.985 1263.87 617.899 1264.27 617.731C1264.66 617.564 1265.02 617.318 1265.32 617.01L1265.82 617.51C1265.51 617.808 1265.27 618.166 1265.1 618.561C1264.93 618.956 1264.84 619.381 1264.84 619.81C1264.84 620.239 1264.93 620.664 1265.1 621.059C1265.27 621.454 1265.51 621.812 1265.82 622.11L1265.32 622.61C1265.02 622.302 1264.66 622.056 1264.27 621.889C1263.87 621.721 1263.45 621.635 1263.02 621.635C1262.59 621.635 1262.17 621.721 1261.77 621.889C1261.38 622.056 1261.02 622.302 1260.72 622.61V622.61Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1125.93 612.26L1125.43 611.76C1125.74 611.462 1125.98 611.104 1126.15 610.709C1126.32 610.314 1126.41 609.889 1126.41 609.46C1126.41 609.031 1126.32 608.606 1126.15 608.211C1125.98 607.816 1125.74 607.458 1125.43 607.16L1125.93 606.66C1126.23 606.968 1126.59 607.214 1126.98 607.381C1127.38 607.549 1127.8 607.635 1128.23 607.635C1128.66 607.635 1129.08 607.549 1129.48 607.381C1129.87 607.214 1130.23 606.968 1130.53 606.66L1131.03 607.16C1130.72 607.458 1130.48 607.816 1130.31 608.211C1130.14 608.606 1130.05 609.031 1130.05 609.46C1130.05 609.889 1130.14 610.314 1130.31 610.709C1130.48 611.104 1130.72 611.462 1131.03 611.76L1130.53 612.26C1130.23 611.952 1129.87 611.706 1129.48 611.539C1129.08 611.371 1128.66 611.285 1128.23 611.285C1127.8 611.285 1127.38 611.371 1126.98 611.539C1126.59 611.706 1126.23 611.952 1125.93 612.26Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1114.07 679.91L1113.57 679.41C1113.88 679.112 1114.12 678.754 1114.29 678.359C1114.46 677.964 1114.55 677.539 1114.55 677.11C1114.55 676.681 1114.46 676.256 1114.29 675.861C1114.12 675.466 1113.88 675.108 1113.57 674.81L1114.07 674.31C1114.37 674.618 1114.73 674.864 1115.12 675.031C1115.52 675.199 1115.94 675.285 1116.37 675.285C1116.8 675.285 1117.22 675.199 1117.62 675.031C1118.01 674.864 1118.37 674.618 1118.67 674.31L1119.17 674.81C1118.86 675.108 1118.62 675.466 1118.45 675.861C1118.28 676.256 1118.19 676.681 1118.19 677.11C1118.19 677.539 1118.28 677.964 1118.45 678.359C1118.62 678.754 1118.86 679.112 1119.17 679.41L1118.67 679.91C1118.37 679.602 1118.01 679.356 1117.62 679.189C1117.22 679.021 1116.8 678.935 1116.37 678.935C1115.94 678.935 1115.52 679.021 1115.12 679.189C1114.73 679.356 1114.37 679.602 1114.07 679.91V679.91Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1184.06 707.29V709.46C1184.05 709.802 1183.91 710.126 1183.67 710.368C1183.43 710.61 1183.1 710.75 1182.76 710.76H1097.37C1097.03 710.752 1096.7 710.613 1096.46 710.371C1096.22 710.129 1096.08 709.802 1096.07 709.46V707.29C1096.08 706.949 1096.22 706.623 1096.46 706.383C1096.7 706.142 1097.03 706.005 1097.37 706H1182.76C1183.1 706.023 1183.41 706.166 1183.65 706.403C1183.89 706.64 1184.03 706.955 1184.06 707.29V707.29Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129 701.75L1110.21 602.93C1110.05 602.102 1109.61 601.356 1108.96 600.819C1108.31 600.282 1107.49 599.989 1106.65 599.99H1084.2C1083.67 599.984 1083.15 600.095 1082.67 600.316C1082.18 600.537 1081.76 600.862 1081.42 601.268C1081.08 601.674 1080.83 602.15 1080.7 602.662C1080.57 603.175 1080.55 603.71 1080.65 604.23L1099.45 703.05C1099.59 703.888 1100.03 704.649 1100.68 705.197C1101.33 705.746 1102.15 706.048 1103 706.05H1125.43C1125.96 706.054 1126.49 705.939 1126.98 705.714C1127.46 705.488 1127.89 705.158 1128.23 704.746C1128.58 704.335 1128.82 703.852 1128.95 703.334C1129.09 702.816 1129.1 702.275 1129 701.75Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1126.38 707.29V709.46C1126.37 709.802 1126.23 710.126 1125.99 710.368C1125.75 710.61 1125.42 710.75 1125.08 710.76H976.2C975.858 710.75 975.533 710.61 975.292 710.368C975.05 710.126 974.91 709.802 974.9 709.46V707.29C974.91 706.949 975.051 706.626 975.292 706.386C975.534 706.146 975.859 706.008 976.2 706H1125.08C1125.42 706.008 1125.75 706.146 1125.99 706.386C1126.23 706.626 1126.37 706.949 1126.38 707.29V707.29Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1125.77 701.75L1107 602.93C1106.84 602.104 1106.4 601.358 1105.75 600.822C1105.11 600.285 1104.29 599.991 1103.45 599.99H959.45C958.921 599.984 958.397 600.095 957.916 600.316C957.435 600.537 957.009 600.862 956.669 601.268C956.329 601.674 956.084 602.15 955.951 602.662C955.818 603.175 955.801 603.71 955.9 604.23L974.69 703.05C974.838 703.888 975.275 704.648 975.926 705.196C976.576 705.744 977.399 706.047 978.25 706.05H1122.25C1122.78 706.048 1123.31 705.929 1123.78 705.701C1124.26 705.473 1124.69 705.141 1125.02 704.73C1125.36 704.319 1125.6 703.839 1125.73 703.324C1125.86 702.808 1125.87 702.271 1125.77 701.75V701.75Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1126.11 707V709.17C1126.1 709.511 1125.96 709.834 1125.72 710.074C1125.48 710.314 1125.15 710.452 1124.81 710.46H975.93C975.589 710.452 975.264 710.314 975.022 710.074C974.781 709.834 974.64 709.511 974.63 709.17V707C974.64 706.658 974.78 706.334 975.022 706.092C975.263 705.85 975.588 705.71 975.93 705.7H1124.81C1125.15 705.71 1125.48 705.85 1125.72 706.092C1125.96 706.334 1126.1 706.658 1126.11 707V707Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1125.5 701.44L1106.71 602.62C1106.56 601.783 1106.13 601.023 1105.48 600.475C1104.83 599.927 1104.01 599.624 1103.16 599.62H959.16C958.63 599.615 958.106 599.728 957.625 599.95C957.144 600.172 956.719 600.498 956.379 600.905C956.04 601.311 955.795 601.788 955.662 602.301C955.529 602.814 955.511 603.35 955.61 603.87L974.4 702.69C974.559 703.518 975.001 704.264 975.651 704.801C976.301 705.338 977.117 705.631 977.96 705.63H1121.96C1122.48 705.628 1123 705.513 1123.47 705.293C1123.94 705.072 1124.36 704.752 1124.7 704.353C1125.04 703.955 1125.28 703.488 1125.42 702.985C1125.56 702.482 1125.59 701.955 1125.5 701.44V701.44Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048 656.18C1044.13 656.18 1043.12 651.77 1044.94 649.43C1041.85 646.43 1037.68 645.35 1035.12 647.16C1032.27 649.16 1032.5 653.95 1035.64 657.83C1038.78 661.71 1043.64 663.22 1046.47 661.21C1047.23 660.627 1047.82 659.846 1048.17 658.953C1048.53 658.06 1048.63 657.087 1048.47 656.14C1048.3 656.15 1048.17 656.18 1048 656.18Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.1 894.45H972.11V901.29H1021.1V894.45Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1021.1 901.28H1004.99L1002.92 894.45H1021.1V901.28Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.66 894.45H1048.67V901.29H1097.66V894.45Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1097.65 901.28H1081.54L1079.48 894.45H1097.65V901.28Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.73 489.77C1158.47 489.15 1158.24 488.51 1158.03 487.85C1158.31 488.472 1158.54 489.114 1158.73 489.77V489.77Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.26 496.24C1159.32 495.358 1159.32 494.472 1159.26 493.59V493.59C1159.26 493.4 1159.26 493.19 1159.26 493C1159.26 493.43 1159.32 493.88 1159.32 494.33C1159.34 494.967 1159.32 495.605 1159.26 496.24V496.24Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.54 491.9C1229.78 489.219 1229.31 486.463 1229.15 483.68L1229.28 483.61C1229.52 486.398 1229.94 489.167 1230.54 491.9V491.9Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.26 496.29C1159.22 496.811 1159.15 497.328 1159.05 497.84C1158.76 499.729 1158.08 501.536 1157.05 503.143C1156.01 504.749 1154.65 506.118 1153.05 507.16C1156.08 504.878 1158.2 501.603 1159.05 497.91C1159.16 497.375 1159.23 496.834 1159.26 496.29V496.29Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1184.06 524C1184.06 523.772 1184.15 523.553 1184.31 523.392C1184.47 523.231 1184.69 523.14 1184.92 523.14H1188.74C1188.97 523.14 1189.19 523.231 1189.35 523.392C1189.51 523.553 1189.6 523.772 1189.6 524C1189.6 524.229 1189.51 524.449 1189.35 524.612C1189.19 524.775 1188.97 524.867 1188.74 524.87H1184.84C1184.64 524.825 1184.45 524.717 1184.31 524.561C1184.17 524.405 1184.08 524.208 1184.06 524Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1181.72 520.83C1181.52 520.765 1181.36 520.627 1181.26 520.443C1181.16 520.26 1181.14 520.046 1181.19 519.845C1181.25 519.644 1181.38 519.473 1181.56 519.366C1181.73 519.258 1181.95 519.224 1182.15 519.27C1190.29 521.09 1193.24 517.02 1194.15 515.11C1194.19 515.008 1194.25 514.915 1194.32 514.837C1194.4 514.759 1194.49 514.698 1194.59 514.658C1194.7 514.618 1194.8 514.6 1194.91 514.604C1195.02 514.609 1195.13 514.636 1195.23 514.685C1195.33 514.734 1195.41 514.802 1195.48 514.886C1195.55 514.97 1195.6 515.068 1195.63 515.173C1195.66 515.278 1195.67 515.388 1195.65 515.496C1195.64 515.604 1195.6 515.708 1195.54 515.8C1194.54 517.8 1191.73 521.8 1184.71 521.26C1183.7 521.235 1182.7 521.091 1181.72 520.83V520.83Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1178.52 511.3C1178.54 510.509 1178.86 509.755 1179.42 509.196C1179.97 508.636 1180.73 508.315 1181.52 508.3C1181.73 508.3 1181.93 508.382 1182.07 508.528C1182.22 508.675 1182.3 508.873 1182.3 509.08C1182.3 509.287 1182.22 509.485 1182.07 509.632C1181.93 509.778 1181.73 509.86 1181.52 509.86C1181.11 509.86 1180.71 510.024 1180.42 510.317C1180.12 510.609 1179.96 511.006 1179.96 511.42C1179.96 511.834 1180.12 512.231 1180.42 512.523C1180.71 512.816 1181.11 512.98 1181.52 512.98H1185C1185.11 512.968 1185.22 512.978 1185.32 513.012C1185.43 513.045 1185.53 513.1 1185.61 513.173C1185.69 513.246 1185.76 513.336 1185.8 513.436C1185.84 513.536 1185.87 513.645 1185.87 513.755C1185.87 513.865 1185.84 513.974 1185.8 514.074C1185.76 514.174 1185.69 514.264 1185.61 514.337C1185.53 514.41 1185.43 514.465 1185.32 514.498C1185.22 514.532 1185.11 514.542 1185 514.53H1181.54C1181.13 514.527 1180.72 514.439 1180.34 514.273C1179.96 514.107 1179.62 513.865 1179.34 513.563C1179.05 513.261 1178.84 512.905 1178.7 512.516C1178.56 512.126 1178.5 511.713 1178.52 511.3V511.3Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "mask-in-svg",
    style: {
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1209.19 523.9L1204.55 508.52L1216.41 496.52L1219.98 510.43L1209.19 523.9ZM1205.82 508.71L1209.51 520.96L1218.74 510.22L1215.93 499.22L1205.82 508.71Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206 506.3C1206 506.3 1187.26 512.95 1166.45 509.76C1166.45 509.76 1168.14 529.67 1181.88 535.89C1181.88 535.89 1199.31 541.05 1210.33 522.44C1210.35 522.44 1206.27 514 1206 506.3Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1209 519.12C1207.33 515.031 1206.32 510.705 1206 506.3C1206 506.3 1187.26 512.95 1166.45 509.76C1166.45 509.76 1167.32 519.99 1172.87 528.07C1172.91 528.08 1192.57 537.08 1209 519.12Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1166.48 509.76L1168.01 517.41C1174.47 519.334 1181.25 519.943 1187.95 519.199C1194.65 518.455 1201.13 516.374 1207.01 513.08C1206.5 511.114 1206.16 509.106 1206.01 507.08L1205.88 506.34C1204.63 506.77 1186.52 512.84 1166.48 509.76Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1212.64 512.08L1214.2 500C1216.2 488.92 1229.87 491.08 1227.45 502.08C1225.03 513.08 1213.85 512.13 1213.85 512.13L1212.64 512.08Z",
    fill: "#956363",
    style: {
      baselineShift: 0,
      fill: "rgb(149, 99, 99)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1224.24 497.27C1224.19 497.348 1224.12 497.414 1224.04 497.464C1223.96 497.515 1223.87 497.549 1223.78 497.565C1223.68 497.581 1223.59 497.578 1223.5 497.557C1223.4 497.535 1223.32 497.495 1223.24 497.44C1222.94 497.167 1222.58 496.964 1222.19 496.845C1221.8 496.726 1221.38 496.693 1220.98 496.75C1220.6 496.858 1220.26 497.045 1219.96 497.299C1219.66 497.552 1219.42 497.866 1219.25 498.22C1218.66 499.315 1218.32 500.527 1218.25 501.77L1218.17 503.07C1218.17 504.07 1216.61 503.77 1216.69 502.9L1216.78 501.69C1216.83 500.158 1217.28 498.665 1218.08 497.36C1218.34 496.821 1218.71 496.347 1219.17 495.971C1219.64 495.596 1220.18 495.329 1220.76 495.19C1221.36 495.113 1221.97 495.158 1222.55 495.321C1223.13 495.484 1223.67 495.763 1224.14 496.14C1224.27 496.296 1224.35 496.488 1224.37 496.689C1224.38 496.891 1224.34 497.094 1224.24 497.27Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1219.13 508.18C1219.13 507.735 1219 507.3 1218.75 506.93C1218.5 506.56 1218.15 506.272 1217.74 506.101C1217.33 505.931 1216.88 505.886 1216.44 505.973C1216 506.06 1215.6 506.274 1215.29 506.589C1214.97 506.904 1214.76 507.305 1214.67 507.741C1214.59 508.178 1214.63 508.63 1214.8 509.041C1214.97 509.452 1215.26 509.804 1215.63 510.051C1216 510.298 1216.43 510.43 1216.88 510.43C1217.48 510.43 1218.05 510.193 1218.47 509.771C1218.89 509.349 1219.13 508.777 1219.13 508.18V508.18Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1215.58 510C1215.96 510.269 1216.41 510.419 1216.88 510.43C1217.18 510.433 1217.47 510.376 1217.74 510.264C1218.02 510.152 1218.27 509.986 1218.48 509.777C1218.69 509.567 1218.85 509.318 1218.96 509.044C1219.08 508.77 1219.13 508.476 1219.13 508.18C1219.13 507.817 1219.04 507.459 1218.87 507.141C1218.69 506.822 1218.44 506.554 1218.13 506.36C1218.33 506.767 1218.45 507.208 1218.48 507.66C1218.48 507.979 1218.42 508.295 1218.3 508.59C1218.17 508.885 1217.99 509.153 1217.77 509.378C1217.54 509.604 1217.27 509.783 1216.98 509.905C1216.69 510.027 1216.37 510.09 1216.05 510.09C1215.89 510.096 1215.73 510.065 1215.58 510V510Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192.72 491.38C1190.83 491.383 1188.98 491.911 1187.38 492.906C1185.77 493.9 1184.47 495.321 1183.63 497.01C1181.57 496.403 1179.35 496.555 1177.39 497.44C1176.45 496.251 1175.25 495.291 1173.89 494.633C1172.52 493.974 1171.03 493.635 1169.51 493.64C1168.45 493.638 1167.39 493.803 1166.38 494.13L1166.15 494.2C1164.18 494.895 1162.47 496.183 1161.27 497.887C1160.06 499.591 1159.41 501.628 1159.4 503.717C1159.4 505.805 1160.04 507.844 1161.24 509.553C1162.45 511.261 1164.15 512.555 1166.12 513.257C1168.08 513.959 1170.22 514.034 1172.23 513.472C1174.24 512.91 1176.03 511.738 1177.35 510.118C1178.67 508.499 1179.46 506.51 1179.6 504.426C1179.74 502.342 1179.24 500.265 1178.15 498.48C1179.74 497.838 1181.49 497.718 1183.15 498.14C1182.79 499.072 1182.58 500.06 1182.55 501.06C1182.55 501.21 1182.55 501.36 1182.55 501.51C1182.56 504.026 1183.51 506.448 1185.2 508.305C1186.9 510.163 1189.23 511.323 1191.73 511.561C1194.23 511.799 1196.74 511.098 1198.75 509.593C1200.77 508.089 1202.16 505.889 1202.64 503.42C1202.76 502.791 1202.82 502.151 1202.82 501.51C1202.82 498.829 1201.75 496.259 1199.86 494.361C1197.97 492.462 1195.4 491.391 1192.72 491.38V491.38ZM1178.34 503.77C1178.33 506.109 1177.4 508.351 1175.75 510.005C1174.09 511.659 1171.85 512.592 1169.51 512.6C1168.66 512.598 1167.82 512.477 1167 512.24C1165.54 511.81 1164.22 511.009 1163.16 509.915C1162.1 508.821 1161.34 507.472 1160.96 505.998C1160.58 504.525 1160.59 502.978 1160.98 501.508C1161.37 500.038 1162.14 498.695 1163.21 497.61C1164.06 496.748 1165.09 496.067 1166.21 495.61L1166.43 495.53C1167.77 495.024 1169.2 494.85 1170.62 495.024C1172.04 495.198 1173.39 495.714 1174.57 496.528C1175.74 497.342 1176.7 498.43 1177.36 499.697C1178.02 500.964 1178.36 502.372 1178.35 503.8L1178.34 503.77ZM1192.72 510.35C1190.38 510.339 1188.14 509.404 1186.48 507.749C1184.83 506.093 1183.9 503.85 1183.89 501.51C1183.89 501.413 1183.89 501.317 1183.89 501.22C1184 498.925 1184.99 496.762 1186.66 495.189C1188.34 493.616 1190.56 492.758 1192.86 492.795C1195.15 492.833 1197.34 493.764 1198.97 495.391C1200.59 497.018 1201.51 499.213 1201.54 501.51C1201.54 502.098 1201.48 502.685 1201.36 503.26C1200.95 505.254 1199.87 507.048 1198.3 508.339C1196.73 509.63 1194.76 510.34 1192.72 510.35V510.35Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1402.4 684.5C1402.4 681.88 1401.36 679.367 1399.51 677.514C1397.65 675.661 1395.14 674.62 1392.52 674.62H1266.42C1265.12 674.62 1263.84 674.876 1262.64 675.372C1261.44 675.869 1260.35 676.597 1259.44 677.514C1258.52 678.432 1257.79 679.521 1257.3 680.72C1256.8 681.918 1256.55 683.203 1256.55 684.5V952.27C1256.55 953.567 1256.8 954.851 1257.3 956.049C1257.79 957.247 1258.52 958.335 1259.44 959.252C1260.35 960.169 1261.44 960.896 1262.64 961.391C1263.84 961.887 1265.12 962.141 1266.42 962.14H1402.42L1402.4 684.5Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1402.4 684.5C1402.4 681.88 1401.36 679.367 1399.51 677.514C1397.65 675.661 1395.14 674.62 1392.52 674.62H1266.42C1265.12 674.62 1263.84 674.876 1262.64 675.372C1261.44 675.869 1260.35 676.597 1259.44 677.514C1258.52 678.432 1257.79 679.521 1257.3 680.72C1256.8 681.918 1256.55 683.203 1256.55 684.5V952.27C1256.55 953.567 1256.8 954.851 1257.3 956.049C1257.79 957.247 1258.52 958.335 1259.44 959.252C1260.35 960.169 1261.44 960.896 1262.64 961.391C1263.84 961.887 1265.12 962.141 1266.42 962.14H1402.42L1402.4 684.5Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1286.34 684.5C1286.34 683.203 1286.09 681.918 1285.59 680.72C1285.1 679.521 1284.37 678.432 1283.45 677.514C1282.54 676.597 1281.45 675.869 1280.25 675.372C1279.05 674.876 1277.77 674.62 1276.47 674.62H1231.26C1229.96 674.62 1228.68 674.876 1227.48 675.372C1226.28 675.869 1225.19 676.597 1224.28 677.514C1223.36 678.432 1222.63 679.521 1222.14 680.72C1221.64 681.918 1221.39 683.203 1221.39 684.5V962.14H1286.34V684.5Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1286.34 684.5C1286.34 683.203 1286.09 681.918 1285.59 680.72C1285.1 679.521 1284.37 678.432 1283.45 677.514C1282.54 676.597 1281.45 675.869 1280.25 675.372C1279.05 674.876 1277.77 674.62 1276.47 674.62H1231.26C1229.96 674.62 1228.68 674.876 1227.48 675.372C1226.28 675.869 1225.19 676.597 1224.28 677.514C1223.36 678.432 1222.63 679.521 1222.14 680.72C1221.64 681.918 1221.39 683.203 1221.39 684.5V962.14H1286.34V684.5Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1313.09 673.59H1377.09C1377.22 673.603 1377.33 673.664 1377.42 673.761C1377.5 673.858 1377.54 673.983 1377.53 674.11C1377.54 674.236 1377.5 674.36 1377.41 674.455C1377.33 674.551 1377.22 674.61 1377.09 674.62H1313.09C1313.03 674.615 1312.97 674.598 1312.91 674.569C1312.86 674.541 1312.81 674.502 1312.77 674.455C1312.73 674.407 1312.7 674.352 1312.68 674.293C1312.66 674.234 1312.65 674.172 1312.66 674.11C1312.65 673.984 1312.69 673.859 1312.77 673.762C1312.85 673.664 1312.96 673.603 1313.09 673.59Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124 706.37H978.2C978.146 706.379 978.09 706.376 978.037 706.361C977.984 706.346 977.935 706.32 977.893 706.285C977.851 706.249 977.817 706.205 977.794 706.155C977.771 706.105 977.759 706.05 977.759 705.995C977.759 705.94 977.771 705.885 977.794 705.835C977.817 705.785 977.851 705.741 977.893 705.705C977.935 705.67 977.984 705.644 978.037 705.629C978.09 705.614 978.146 705.611 978.2 705.62H1124C1124.05 705.611 1124.11 705.614 1124.16 705.629C1124.22 705.644 1124.27 705.67 1124.31 705.705C1124.35 705.741 1124.38 705.785 1124.41 705.835C1124.43 705.885 1124.44 705.94 1124.44 705.995C1124.44 706.05 1124.43 706.105 1124.41 706.155C1124.38 706.205 1124.35 706.249 1124.31 706.285C1124.27 706.32 1124.22 706.346 1124.16 706.361C1124.11 706.376 1124.05 706.379 1124 706.37V706.37Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1377.86 718.07C1369.4 724.45 1370.28 729.5 1370.38 729.63C1370.48 729.76 1382.82 731.86 1391.28 725.47C1399.74 719.08 1404.09 710.61 1401.01 706.47C1397.93 702.33 1386.31 711.69 1377.86 718.07Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1348.61 705.23C1354.49 709.67 1355.47 718.32 1355.37 718.41C1355.27 718.5 1346.72 719.96 1340.84 715.53C1334.96 711.1 1333.75 707.15 1335.9 704.31C1338.05 701.47 1342.74 700.79 1348.61 705.23Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381.4 688.292C1383.81 675.737 1381.17 664.673 1375.49 663.581C1369.81 662.488 1363.25 671.781 1360.83 684.336C1358.42 696.891 1361.06 707.954 1366.74 709.047C1372.42 710.139 1378.98 700.847 1381.4 688.292Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1377.86 718.07C1369.4 724.45 1370.28 729.5 1370.38 729.63C1370.48 729.76 1382.82 731.86 1391.28 725.47C1399.74 719.08 1404.09 710.61 1401.01 706.47C1397.93 702.33 1386.31 711.69 1377.86 718.07Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1348.61 705.23C1354.49 709.67 1355.47 718.32 1355.37 718.41C1355.27 718.5 1346.72 719.96 1340.84 715.53C1334.96 711.1 1333.75 707.15 1335.9 704.31C1338.05 701.47 1342.74 700.79 1348.61 705.23Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1381.4 688.292C1383.81 675.737 1381.17 664.673 1375.49 663.581C1369.81 662.488 1363.25 671.781 1360.83 684.336C1358.42 696.891 1361.06 707.954 1366.74 709.047C1372.42 710.139 1378.98 700.847 1381.4 688.292Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1389.5 718L1384.84 719.55C1384.07 719.818 1383.31 720.129 1382.57 720.48L1380.32 721.48L1376.65 723.58C1375.51 724.4 1374.34 725.2 1373.23 726.07C1371.53 727.51 1369.94 729.078 1368.47 730.76C1365.59 734.183 1363.4 738.128 1362.01 742.38C1361.84 742.89 1361.69 743.38 1361.55 743.93L1371.07 679.93V680.15V680.05V679.93V679.8L1361.53 742.5C1361.53 742.03 1361.53 741.56 1361.53 741.09C1361.6 739.66 1361.63 738.22 1361.53 736.78C1361.44 732.707 1360.64 728.68 1359.17 724.88C1357.66 721.071 1355.26 717.679 1352.17 714.99C1349.05 712.362 1345.44 710.393 1341.54 709.2V709.32C1345.41 710.525 1349 712.505 1352.08 715.14C1355.12 717.826 1357.48 721.204 1358.94 724.99C1359.49 726.375 1359.95 727.795 1360.31 729.24C1360.92 731.709 1361.25 734.238 1361.31 736.78C1361.37 738.805 1361.32 740.831 1361.15 742.85C1361.07 743.85 1360.98 744.85 1360.88 745.85L1360.72 747.27L1360.48 748.87V748.97H1360.76V748.89C1360.76 748.73 1360.76 748.56 1360.82 748.4C1360.85 748.316 1360.87 748.229 1360.88 748.14L1360.95 747.44C1360.95 747.18 1361.03 746.91 1361.07 746.64C1361.3 745.205 1361.64 743.788 1362.07 742.4C1362.76 740.294 1363.65 738.258 1364.72 736.32C1365.79 734.377 1367.05 732.545 1368.48 730.85C1369.93 729.169 1371.51 727.605 1373.2 726.17C1374.31 725.31 1375.46 724.51 1376.59 723.69L1380.25 721.59L1382.49 720.59C1383.23 720.236 1383.99 719.926 1384.76 719.66L1389.41 718.08L1389.5 718ZM1361.5 742.87C1361.5 742.5 1361.5 742.12 1361.58 741.74V742.67L1361.52 743.06C1361.46 743 1361.47 742.91 1361.47 742.84L1361.5 742.87ZM1361.09 747.33V747.15V746.96C1361.09 747.05 1361.08 747.18 1361.06 747.3L1361.09 747.33Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1389.5 718L1384.84 719.55C1384.07 719.818 1383.31 720.129 1382.57 720.48L1380.32 721.48L1376.65 723.58C1375.51 724.4 1374.34 725.2 1373.23 726.07C1371.53 727.51 1369.94 729.078 1368.47 730.76C1365.59 734.183 1363.4 738.128 1362.01 742.38C1361.84 742.89 1361.69 743.38 1361.55 743.93L1371.07 679.93V680.15V680.05V679.93V679.8L1361.53 742.5C1361.53 742.03 1361.53 741.56 1361.53 741.09C1361.6 739.66 1361.63 738.22 1361.53 736.78C1361.44 732.707 1360.64 728.68 1359.17 724.88C1357.66 721.071 1355.26 717.679 1352.17 714.99C1349.05 712.362 1345.44 710.393 1341.54 709.2V709.32C1345.41 710.525 1349 712.505 1352.08 715.14C1355.12 717.826 1357.48 721.204 1358.94 724.99C1359.49 726.375 1359.95 727.795 1360.31 729.24C1360.92 731.709 1361.25 734.238 1361.31 736.78C1361.37 738.805 1361.32 740.831 1361.15 742.85C1361.07 743.85 1360.98 744.85 1360.88 745.85L1360.72 747.27L1360.48 748.87V748.97H1360.76V748.89C1360.76 748.73 1360.76 748.56 1360.82 748.4C1360.85 748.316 1360.87 748.229 1360.88 748.14L1360.95 747.44C1360.95 747.18 1361.03 746.91 1361.07 746.64C1361.3 745.205 1361.64 743.788 1362.07 742.4C1362.76 740.294 1363.65 738.258 1364.72 736.32C1365.79 734.377 1367.05 732.545 1368.48 730.85C1369.93 729.169 1371.51 727.605 1373.2 726.17C1374.31 725.31 1375.46 724.51 1376.59 723.69L1380.25 721.59L1382.49 720.59C1383.23 720.236 1383.99 719.926 1384.76 719.66L1389.41 718.08L1389.5 718ZM1361.5 742.87C1361.5 742.5 1361.5 742.12 1361.58 741.74V742.67L1361.52 743.06C1361.46 743 1361.47 742.91 1361.47 742.84L1361.5 742.87ZM1361.09 747.33V747.15V746.96C1361.09 747.05 1361.08 747.18 1361.06 747.3L1361.09 747.33Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1405.93 786.3H1319.73C1319.01 786.3 1318.33 786.016 1317.82 785.509C1317.31 785.003 1317.03 784.316 1317.03 783.6C1317.03 782.884 1317.31 782.197 1317.82 781.691C1318.33 781.184 1319.01 780.9 1319.73 780.9H1405.93C1406.65 780.9 1407.33 781.184 1407.84 781.691C1408.35 782.197 1408.63 782.884 1408.63 783.6C1408.63 784.316 1408.35 785.003 1407.84 785.509C1407.33 786.016 1406.65 786.3 1405.93 786.3V786.3Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1402.33 786.3L1416.63 962.1H1413.83L1392.33 786.3H1402.33Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1322.83 786.3L1308.53 962.1H1311.43L1332.83 786.3H1322.83Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1322.83 786.3L1322.43 789.7H1327.33L1310.13 962.1H1311.43L1332.83 786.3H1322.83Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1406.23 853.7H1403.73L1392.33 786.3H1402.33L1416.63 962.1H1415.23L1406.23 853.7Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.43 786.3L1358.73 962.1H1361.63L1366.43 786.3H1356.43Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1356.43 786.3L1358.73 962.1H1361.63L1366.43 786.3H1356.43Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.93 737H1341.53V742.8H1387.93V737Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381.93 780.9H1347.33L1344.73 742.8H1384.53L1381.93 780.9Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1387.83 737H1341.43V742.8H1387.83V737Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1381.83 780.9H1347.23L1344.63 742.8H1384.43L1381.83 780.9Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1387.83 737H1380.33V742.8H1344.73L1344.93 744.4H1373.43L1373.53 780.9H1381.93L1384.53 742.8H1387.83V737Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.67 547.63H577.67V483.52C577.67 480.072 579.04 476.766 581.478 474.328C583.916 471.89 587.222 470.52 590.67 470.52H703.36V472.52H590.67C587.753 472.52 584.955 473.679 582.892 475.742C580.829 477.805 579.67 480.603 579.67 483.52V547.63Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.67 537.24H577.67V526.24C577.67 523.323 576.511 520.525 574.448 518.462C572.385 516.399 569.587 515.24 566.67 515.24H559.3C555.852 515.24 552.546 513.87 550.108 511.432C547.67 508.994 546.3 505.688 546.3 502.24V471.52H548.3V502.21C548.3 505.127 549.459 507.925 551.522 509.988C553.585 512.051 556.383 513.21 559.3 513.21H566.67C570.118 513.21 573.424 514.58 575.862 517.018C578.3 519.456 579.67 522.762 579.67 526.21V537.24Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595 472.52H592.91V470.52H595C597.917 470.52 600.715 469.361 602.778 467.298C604.841 465.235 606 462.437 606 459.52V449.31C606.005 443.965 608.131 438.84 611.911 435.061C615.69 431.281 620.815 429.155 626.16 429.15H649.7V431.15H626.11C621.305 431.171 616.703 433.093 613.31 436.495C609.917 439.898 608.008 444.505 608 449.31V459.52C608 462.968 606.63 466.274 604.192 468.712C601.754 471.15 598.448 472.52 595 472.52V472.52Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.65 433.18C651.324 433.18 652.68 431.823 652.68 430.15C652.68 428.477 651.324 427.12 649.65 427.12C647.977 427.12 646.62 428.477 646.62 430.15C646.62 431.823 647.977 433.18 649.65 433.18Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.3 474.54C548.973 474.54 550.33 473.183 550.33 471.51C550.33 469.837 548.973 468.48 547.3 468.48C545.627 468.48 544.27 469.837 544.27 471.51C544.27 473.183 545.627 474.54 547.3 474.54Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.83 550.66C580.504 550.66 581.86 549.303 581.86 547.63C581.86 545.957 580.504 544.6 578.83 544.6C577.157 544.6 575.8 545.957 575.8 547.63C575.8 549.303 577.157 550.66 578.83 550.66Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.46 581.13H1033.46V319.06C1033.46 316.143 1032.3 313.345 1030.24 311.282C1028.18 309.219 1025.38 308.06 1022.46 308.06H785.62V306.06H1022.46C1025.91 306.06 1029.21 307.43 1031.65 309.868C1034.09 312.306 1035.46 315.612 1035.46 319.06V581.13Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.44 585.73C1036.11 585.73 1037.47 584.373 1037.47 582.7C1037.47 581.027 1036.11 579.67 1034.44 579.67C1032.77 579.67 1031.41 581.027 1031.41 582.7C1031.41 584.373 1032.77 585.73 1034.44 585.73Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.46 518H1033.46V507C1033.46 503.552 1034.83 500.246 1037.27 497.808C1039.71 495.37 1043.01 494 1046.46 494H1057.89C1062.39 493.981 1066.69 492.182 1069.87 488.996C1073.04 485.81 1074.82 481.497 1074.82 477V402.27H1076.82V477C1076.82 482.027 1074.83 486.849 1071.28 490.41C1067.73 493.972 1062.92 495.981 1057.89 496H1046.46C1043.54 496 1040.74 497.159 1038.68 499.222C1036.62 501.285 1035.46 504.083 1035.46 507V518Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.82 349.42H857.17V347.42H918.82C923.241 347.417 927.481 345.661 930.608 342.535C933.735 339.41 935.495 335.171 935.5 330.75V319.06C935.5 315.612 936.87 312.306 939.308 309.868C941.746 307.43 945.052 306.06 948.5 306.06H1018.23V308.06H948.5C945.583 308.06 942.785 309.219 940.722 311.282C938.659 313.345 937.5 316.143 937.5 319.06V330.75C937.495 335.702 935.525 340.449 932.022 343.949C928.52 347.45 923.772 349.417 918.82 349.42V349.42Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.48 268.72C915.154 268.72 916.51 267.363 916.51 265.69C916.51 264.017 915.154 262.66 913.48 262.66C911.807 262.66 910.45 264.017 910.45 265.69C910.45 267.363 911.807 268.72 913.48 268.72Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.17 351.45C858.844 351.45 860.2 350.093 860.2 348.42C860.2 346.747 858.844 345.39 857.17 345.39C855.497 345.39 854.14 346.747 854.14 348.42C854.14 350.093 855.497 351.45 857.17 351.45Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.82 405.3C1077.49 405.3 1078.85 403.943 1078.85 402.27C1078.85 400.597 1077.49 399.24 1075.82 399.24C1074.15 399.24 1072.79 400.597 1072.79 402.27C1072.79 403.943 1074.15 405.3 1075.82 405.3Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.46 464.46H1033.46V453.46C1033.46 450.543 1032.3 447.745 1030.24 445.682C1028.18 443.619 1025.38 442.46 1022.46 442.46H1011C1005.98 442.442 1001.18 440.441 997.635 436.895C994.089 433.349 992.088 428.545 992.07 423.53V378.74H994.07V423.51C994.088 427.994 995.878 432.29 999.049 435.461C1002.22 438.632 1006.52 440.422 1011 440.44H1022.44C1025.89 440.44 1029.19 441.81 1031.63 444.248C1034.07 446.686 1035.44 449.992 1035.44 453.44L1035.46 464.46Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.09 381.77C994.764 381.77 996.12 380.413 996.12 378.74C996.12 377.067 994.764 375.71 993.09 375.71C991.417 375.71 990.06 377.067 990.06 378.74C990.06 380.413 991.417 381.77 993.09 381.77Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.26 308.06H968.18C964.732 308.06 961.426 306.69 958.988 304.252C956.55 301.814 955.18 298.508 955.18 295.06V283.37C955.175 278.948 953.416 274.708 950.289 271.581C947.162 268.454 942.922 266.695 938.5 266.69H913.5V264.69H938.5C943.453 264.695 948.201 266.665 951.703 270.167C955.205 273.669 957.175 278.417 957.18 283.37V295.06C957.18 297.977 958.339 300.775 960.402 302.838C962.465 304.901 965.263 306.06 968.18 306.06H970.26V308.06Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(0, 0, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.38 397.9H702.67C699.594 397.9 697.1 400.394 697.1 403.47V542.4C697.1 545.476 699.594 547.97 702.67 547.97H909.38C912.456 547.97 914.95 545.476 914.95 542.4V403.47C914.95 400.394 912.456 397.9 909.38 397.9Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M909.38 397.9H702.67C699.594 397.9 697.1 400.394 697.1 403.47V542.4C697.1 545.476 699.594 547.97 702.67 547.97H909.38C912.456 547.97 914.95 545.476 914.95 542.4V403.47C914.95 400.394 912.456 397.9 909.38 397.9Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.25 397.9H909.38C910.857 397.9 912.274 398.487 913.319 399.531C914.363 400.576 914.95 401.993 914.95 403.47V408.8H905.26V397.9H905.25Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M905.25 397.9H909.38C910.857 397.9 912.274 398.487 913.319 399.531C914.363 400.576 914.95 401.993 914.95 403.47V408.8H905.26V397.9H905.25Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.92 397.9H700.21C697.134 397.9 694.64 400.394 694.64 403.47V542.4C694.64 545.476 697.134 547.97 700.21 547.97H906.92C909.996 547.97 912.49 545.476 912.49 542.4V403.47C912.49 400.394 909.996 397.9 906.92 397.9Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M906.92 397.9H700.21C697.134 397.9 694.64 400.394 694.64 403.47V542.4C694.64 545.476 697.134 547.97 700.21 547.97H906.92C909.996 547.97 912.49 545.476 912.49 542.4V403.47C912.49 400.394 909.996 397.9 906.92 397.9Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.21 397.9H761.5V548H700.21C698.733 548 697.316 547.413 696.272 546.369C695.227 545.324 694.64 543.907 694.64 542.43V403.48C694.639 402.748 694.782 402.022 695.061 401.345C695.341 400.668 695.751 400.053 696.268 399.535C696.785 399.017 697.4 398.605 698.076 398.325C698.753 398.044 699.478 397.9 700.21 397.9V397.9Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M700.21 397.9H761.5V548H700.21C698.733 548 697.316 547.413 696.272 546.369C695.227 545.324 694.64 543.907 694.64 542.43V403.48C694.639 402.748 694.782 402.022 695.061 401.345C695.341 400.668 695.751 400.053 696.268 399.535C696.785 399.017 697.4 398.605 698.076 398.325C698.753 398.044 699.478 397.9 700.21 397.9V397.9Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.49 408.8V403.48C912.49 402.747 912.346 402.022 912.065 401.345C911.785 400.668 911.374 400.052 910.856 399.534C910.338 399.016 909.722 398.605 909.045 398.325C908.368 398.044 907.643 397.9 906.91 397.9H700.21C699.478 397.9 698.753 398.044 698.076 398.325C697.4 398.605 696.785 399.017 696.268 399.535C695.751 400.053 695.341 400.668 695.061 401.345C694.782 402.022 694.639 402.748 694.64 403.48V408.8H912.49Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.72 466.07C724.482 466.07 725.91 464.642 725.91 462.88C725.91 461.118 724.482 459.69 722.72 459.69C720.958 459.69 719.53 461.118 719.53 462.88C719.53 464.642 720.958 466.07 722.72 466.07Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.02 461.54H730.23C729.788 461.54 729.43 461.898 729.43 462.34V463.47C729.43 463.912 729.788 464.27 730.23 464.27H749.02C749.462 464.27 749.82 463.912 749.82 463.47V462.34C749.82 461.898 749.462 461.54 749.02 461.54Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M749.02 461.54H730.23C729.788 461.54 729.43 461.898 729.43 462.34V463.47C729.43 463.912 729.788 464.27 730.23 464.27H749.02C749.462 464.27 749.82 463.912 749.82 463.47V462.34C749.82 461.898 749.462 461.54 749.02 461.54Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.72 477.9C724.482 477.9 725.91 476.472 725.91 474.71C725.91 472.948 724.482 471.52 722.72 471.52C720.958 471.52 719.53 472.948 719.53 474.71C719.53 476.472 720.958 477.9 722.72 477.9Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.02 473.37H730.23C729.788 473.37 729.43 473.728 729.43 474.17V475.3C729.43 475.742 729.788 476.1 730.23 476.1H749.02C749.462 476.1 749.82 475.742 749.82 475.3V474.17C749.82 473.728 749.462 473.37 749.02 473.37Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M749.02 473.37H730.23C729.788 473.37 729.43 473.728 729.43 474.17V475.3C729.43 475.742 729.788 476.1 730.23 476.1H749.02C749.462 476.1 749.82 475.742 749.82 475.3V474.17C749.82 473.728 749.462 473.37 749.02 473.37Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.56 434.58C712.183 434.58 714.31 432.453 714.31 429.83C714.31 427.207 712.183 425.08 709.56 425.08C706.937 425.08 704.81 427.207 704.81 429.83C704.81 432.453 706.937 434.58 709.56 434.58Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.56 452.92C712.183 452.92 714.31 450.793 714.31 448.17C714.31 445.547 712.183 443.42 709.56 443.42C706.937 443.42 704.81 445.547 704.81 448.17C704.81 450.793 706.937 452.92 709.56 452.92Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.56 495.81C712.183 495.81 714.31 493.683 714.31 491.06C714.31 488.437 712.183 486.31 709.56 486.31C706.937 486.31 704.81 488.437 704.81 491.06C704.81 493.683 706.937 495.81 709.56 495.81Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.72 508.95C724.482 508.95 725.91 507.522 725.91 505.76C725.91 503.998 724.482 502.57 722.72 502.57C720.958 502.57 719.53 503.998 719.53 505.76C719.53 507.522 720.958 508.95 722.72 508.95Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.02 504.43H730.23C729.788 504.43 729.43 504.788 729.43 505.23V506.36C729.43 506.802 729.788 507.16 730.23 507.16H749.02C749.462 507.16 749.82 506.802 749.82 506.36V505.23C749.82 504.788 749.462 504.43 749.02 504.43Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M749.02 504.43H730.23C729.788 504.43 729.43 504.788 729.43 505.23V506.36C729.43 506.802 729.788 507.16 730.23 507.16H749.02C749.462 507.16 749.82 506.802 749.82 506.36V505.23C749.82 504.788 749.462 504.43 749.02 504.43Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.72 520.79C724.482 520.79 725.91 519.362 725.91 517.6C725.91 515.838 724.482 514.41 722.72 514.41C720.958 514.41 719.53 515.838 719.53 517.6C719.53 519.362 720.958 520.79 722.72 520.79Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.02 516.26H730.23C729.788 516.26 729.43 516.618 729.43 517.06V518.19C729.43 518.632 729.788 518.99 730.23 518.99H749.02C749.462 518.99 749.82 518.632 749.82 518.19V517.06C749.82 516.618 749.462 516.26 749.02 516.26Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M749.02 516.26H730.23C729.788 516.26 729.43 516.618 729.43 517.06V518.19C729.43 518.632 729.788 518.99 730.23 518.99H749.02C749.462 518.99 749.82 518.632 749.82 518.19V517.06C749.82 516.618 749.462 516.26 749.02 516.26Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.01 446.8H720.32C719.878 446.8 719.52 447.158 719.52 447.6V448.73C719.52 449.172 719.878 449.53 720.32 449.53H749.01C749.452 449.53 749.81 449.172 749.81 448.73V447.6C749.81 447.158 749.452 446.8 749.01 446.8Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M749.01 446.8H720.32C719.878 446.8 719.52 447.158 719.52 447.6V448.73C719.52 449.172 719.878 449.53 720.32 449.53H749.01C749.452 449.53 749.81 449.172 749.81 448.73V447.6C749.81 447.158 749.452 446.8 749.01 446.8Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.01 428.47H720.32C719.878 428.47 719.52 428.828 719.52 429.27V430.4C719.52 430.842 719.878 431.2 720.32 431.2H749.01C749.452 431.2 749.81 430.842 749.81 430.4V429.27C749.81 428.828 749.452 428.47 749.01 428.47Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M749.01 428.47H720.32C719.878 428.47 719.52 428.828 719.52 429.27V430.4C719.52 430.842 719.878 431.2 720.32 431.2H749.01C749.452 431.2 749.81 430.842 749.81 430.4V429.27C749.81 428.828 749.452 428.47 749.01 428.47Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.01 488.87H720.32C719.878 488.87 719.52 489.228 719.52 489.67V490.8C719.52 491.242 719.878 491.6 720.32 491.6H749.01C749.452 491.6 749.81 491.242 749.81 490.8V489.67C749.81 489.228 749.452 488.87 749.01 488.87Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M749.01 488.87H720.32C719.878 488.87 719.52 489.228 719.52 489.67V490.8C719.52 491.242 719.878 491.6 720.32 491.6H749.01C749.452 491.6 749.81 491.242 749.81 490.8V489.67C749.81 489.228 749.452 488.87 749.01 488.87Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.83 428.47H782.8C782.358 428.47 782 428.828 782 429.27V430.4C782 430.842 782.358 431.2 782.8 431.2H840.83C841.272 431.2 841.63 430.842 841.63 430.4V429.27C841.63 428.828 841.272 428.47 840.83 428.47Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.36 428.47H847C846.558 428.47 846.2 428.828 846.2 429.27V430.4C846.2 430.842 846.558 431.2 847 431.2H890.36C890.802 431.2 891.16 430.842 891.16 430.4V429.27C891.16 428.828 890.802 428.47 890.36 428.47Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.83 489.25H782.8C782.358 489.25 782 489.608 782 490.05V491.18C782 491.622 782.358 491.98 782.8 491.98H840.83C841.272 491.98 841.63 491.622 841.63 491.18V490.05C841.63 489.608 841.272 489.25 840.83 489.25Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.36 489.25H847C846.558 489.25 846.2 489.608 846.2 490.05V491.18C846.2 491.622 846.558 491.98 847 491.98H890.36C890.802 491.98 891.16 491.622 891.16 491.18V490.05C891.16 489.608 890.802 489.25 890.36 489.25Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.82 504.43H815.07C814.628 504.43 814.27 504.788 814.27 505.23V506.36C814.27 506.802 814.628 507.16 815.07 507.16H840.82C841.262 507.16 841.62 506.802 841.62 506.36V505.23C841.62 504.788 841.262 504.43 840.82 504.43Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.36 504.43H847C846.558 504.43 846.2 504.788 846.2 505.23V506.36C846.2 506.802 846.558 507.16 847 507.16H890.36C890.802 507.16 891.16 506.802 891.16 506.36V505.23C891.16 504.788 890.802 504.43 890.36 504.43Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.82 516.23H815.07C814.628 516.23 814.27 516.588 814.27 517.03V518.16C814.27 518.602 814.628 518.96 815.07 518.96H840.82C841.262 518.96 841.62 518.602 841.62 518.16V517.03C841.62 516.588 841.262 516.23 840.82 516.23Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.36 516.23H847C846.558 516.23 846.2 516.588 846.2 517.03V518.16C846.2 518.602 846.558 518.96 847 518.96H890.36C890.802 518.96 891.16 518.602 891.16 518.16V517.03C891.16 516.588 890.802 516.23 890.36 516.23Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.83 446.69H782.8C782.358 446.69 782 447.048 782 447.49V448.62C782 449.062 782.358 449.42 782.8 449.42H840.83C841.272 449.42 841.63 449.062 841.63 448.62V447.49C841.63 447.048 841.272 446.69 840.83 446.69Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.36 446.69H847C846.558 446.69 846.2 447.048 846.2 447.49V448.62C846.2 449.062 846.558 449.42 847 449.42H890.36C890.802 449.42 891.16 449.062 891.16 448.62V447.49C891.16 447.048 890.802 446.69 890.36 446.69Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.82 461.86H815.07C814.628 461.86 814.27 462.218 814.27 462.66V463.79C814.27 464.232 814.628 464.59 815.07 464.59H840.82C841.262 464.59 841.62 464.232 841.62 463.79V462.66C841.62 462.218 841.262 461.86 840.82 461.86Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.36 461.86H847C846.558 461.86 846.2 462.218 846.2 462.66V463.79C846.2 464.232 846.558 464.59 847 464.59H890.36C890.802 464.59 891.16 464.232 891.16 463.79V462.66C891.16 462.218 890.802 461.86 890.36 461.86Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.82 473.66H815.07C814.628 473.66 814.27 474.018 814.27 474.46V475.59C814.27 476.032 814.628 476.39 815.07 476.39H840.82C841.262 476.39 841.62 476.032 841.62 475.59V474.46C841.62 474.018 841.262 473.66 840.82 473.66Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.36 473.66H847C846.558 473.66 846.2 474.018 846.2 474.46V475.59C846.2 476.032 846.558 476.39 847 476.39H890.36C890.802 476.39 891.16 476.032 891.16 475.59V474.46C891.16 474.018 890.802 473.66 890.36 473.66Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      baselineShift: 0,
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M840.82 504.43H815.07C814.628 504.43 814.27 504.788 814.27 505.23V506.36C814.27 506.802 814.628 507.16 815.07 507.16H840.82C841.262 507.16 841.62 506.802 841.62 506.36V505.23C841.62 504.788 841.262 504.43 840.82 504.43Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      baselineShift: 0,
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M890.36 504.43H847C846.558 504.43 846.2 504.788 846.2 505.23V506.36C846.2 506.802 846.558 507.16 847 507.16H890.36C890.802 507.16 891.16 506.802 891.16 506.36V505.23C891.16 504.788 890.802 504.43 890.36 504.43Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      baselineShift: 0,
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M840.82 516.23H815.07C814.628 516.23 814.27 516.588 814.27 517.03V518.16C814.27 518.602 814.628 518.96 815.07 518.96H840.82C841.262 518.96 841.62 518.602 841.62 518.16V517.03C841.62 516.588 841.262 516.23 840.82 516.23Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      baselineShift: 0,
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M890.36 516.23H847C846.558 516.23 846.2 516.588 846.2 517.03V518.16C846.2 518.602 846.558 518.96 847 518.96H890.36C890.802 518.96 891.16 518.602 891.16 518.16V517.03C891.16 516.588 890.802 516.23 890.36 516.23Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      baselineShift: 0,
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M840.82 461.86H815.07C814.628 461.86 814.27 462.218 814.27 462.66V463.79C814.27 464.232 814.628 464.59 815.07 464.59H840.82C841.262 464.59 841.62 464.232 841.62 463.79V462.66C841.62 462.218 841.262 461.86 840.82 461.86Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      baselineShift: 0,
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M890.36 461.86H847C846.558 461.86 846.2 462.218 846.2 462.66V463.79C846.2 464.232 846.558 464.59 847 464.59H890.36C890.802 464.59 891.16 464.232 891.16 463.79V462.66C891.16 462.218 890.802 461.86 890.36 461.86Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      baselineShift: 0,
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M840.82 473.66H815.07C814.628 473.66 814.27 474.018 814.27 474.46V475.59C814.27 476.032 814.628 476.39 815.07 476.39H840.82C841.262 476.39 841.62 476.032 841.62 475.59V474.46C841.62 474.018 841.262 473.66 840.82 473.66Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      baselineShift: 0,
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M890.36 473.66H847C846.558 473.66 846.2 474.018 846.2 474.46V475.59C846.2 476.032 846.558 476.39 847 476.39H890.36C890.802 476.39 891.16 476.032 891.16 475.59V474.46C891.16 474.018 890.802 473.66 890.36 473.66Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M704.81 405.24C705.854 405.24 706.7 404.394 706.7 403.35C706.7 402.306 705.854 401.46 704.81 401.46C703.766 401.46 702.92 402.306 702.92 403.35C702.92 404.394 703.766 405.24 704.81 405.24Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.85,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M713.68 405.24C714.724 405.24 715.57 404.394 715.57 403.35C715.57 402.306 714.724 401.46 713.68 401.46C712.636 401.46 711.79 402.306 711.79 403.35C711.79 404.394 712.636 405.24 713.68 405.24Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.85,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M722.55 405.24C723.594 405.24 724.44 404.394 724.44 403.35C724.44 402.306 723.594 401.46 722.55 401.46C721.506 401.46 720.66 402.306 720.66 403.35C720.66 404.394 721.506 405.24 722.55 405.24Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.85,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M709.56 434.58C712.183 434.58 714.31 432.453 714.31 429.83C714.31 427.207 712.183 425.08 709.56 425.08C706.937 425.08 704.81 427.207 704.81 429.83C704.81 432.453 706.937 434.58 709.56 434.58Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M709.56 452.92C712.183 452.92 714.31 450.793 714.31 448.17C714.31 445.547 712.183 443.42 709.56 443.42C706.937 443.42 704.81 445.547 704.81 448.17C704.81 450.793 706.937 452.92 709.56 452.92Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M709.56 495.81C712.183 495.81 714.31 493.683 714.31 491.06C714.31 488.437 712.183 486.31 709.56 486.31C706.937 486.31 704.81 488.437 704.81 491.06C704.81 493.683 706.937 495.81 709.56 495.81Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M789.74 229.22H583.03C579.954 229.22 577.46 231.714 577.46 234.79V373.72C577.46 376.796 579.954 379.29 583.03 379.29H789.74C792.816 379.29 795.31 376.796 795.31 373.72V234.79C795.31 231.714 792.816 229.22 789.74 229.22Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M789.74 229.22H583.03C579.954 229.22 577.46 231.714 577.46 234.79V373.72C577.46 376.796 579.954 379.29 583.03 379.29H789.74C792.816 379.29 795.31 376.796 795.31 373.72V234.79C795.31 231.714 792.816 229.22 789.74 229.22Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.62 229.22H789.75C791.227 229.22 792.644 229.807 793.689 230.851C794.733 231.896 795.32 233.313 795.32 234.79V240.12H785.63V229.22H785.62Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M785.62 229.22H789.75C791.227 229.22 792.644 229.807 793.689 230.851C794.733 231.896 795.32 233.313 795.32 234.79V240.12H785.63V229.22H785.62Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.28 229.22H580.57C577.494 229.22 575 231.714 575 234.79V373.72C575 376.796 577.494 379.29 580.57 379.29H787.28C790.356 379.29 792.85 376.796 792.85 373.72V234.79C792.85 231.714 790.356 229.22 787.28 229.22Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M787.28 229.22H580.57C577.494 229.22 575 231.714 575 234.79V373.72C575 376.796 577.494 379.29 580.57 379.29H787.28C790.356 379.29 792.85 376.796 792.85 373.72V234.79C792.85 231.714 790.356 229.22 787.28 229.22Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.58 229.22H641.87V379.29H580.58C579.103 379.29 577.686 378.703 576.641 377.659C575.597 376.614 575.01 375.197 575.01 373.72V234.79C575.01 233.313 575.597 231.896 576.641 230.851C577.686 229.807 579.103 229.22 580.58 229.22V229.22Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M580.58 229.22H641.87V379.29H580.58C579.103 379.29 577.686 378.703 576.641 377.659C575.597 376.614 575.01 375.197 575.01 373.72V234.79C575.01 233.313 575.597 231.896 576.641 230.851C577.686 229.807 579.103 229.22 580.58 229.22V229.22Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.85 240.12V234.79C792.85 233.313 792.263 231.896 791.219 230.851C790.174 229.807 788.757 229.22 787.28 229.22H580.58C579.102 229.22 577.684 229.807 576.638 230.851C575.592 231.895 575.003 233.312 575 234.79V240.12H792.85Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.08 297.38C604.842 297.38 606.27 295.952 606.27 294.19C606.27 292.428 604.842 291 603.08 291C601.318 291 599.89 292.428 599.89 294.19C599.89 295.952 601.318 297.38 603.08 297.38Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.38 292.86H610.59C610.148 292.86 609.79 293.218 609.79 293.66V294.79C609.79 295.232 610.148 295.59 610.59 295.59H629.38C629.822 295.59 630.18 295.232 630.18 294.79V293.66C630.18 293.218 629.822 292.86 629.38 292.86Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M629.38 292.86H610.59C610.148 292.86 609.79 293.218 609.79 293.66V294.79C609.79 295.232 610.148 295.59 610.59 295.59H629.38C629.822 295.59 630.18 295.232 630.18 294.79V293.66C630.18 293.218 629.822 292.86 629.38 292.86Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.08 309.22C604.842 309.22 606.27 307.792 606.27 306.03C606.27 304.268 604.842 302.84 603.08 302.84C601.318 302.84 599.89 304.268 599.89 306.03C599.89 307.792 601.318 309.22 603.08 309.22Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.38 304.69H610.59C610.148 304.69 609.79 305.048 609.79 305.49V306.62C609.79 307.062 610.148 307.42 610.59 307.42H629.38C629.822 307.42 630.18 307.062 630.18 306.62V305.49C630.18 305.048 629.822 304.69 629.38 304.69Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M629.38 304.69H610.59C610.148 304.69 609.79 305.048 609.79 305.49V306.62C609.79 307.062 610.148 307.42 610.59 307.42H629.38C629.822 307.42 630.18 307.062 630.18 306.62V305.49C630.18 305.048 629.822 304.69 629.38 304.69Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.92 265.9C592.543 265.9 594.67 263.773 594.67 261.15C594.67 258.527 592.543 256.4 589.92 256.4C587.297 256.4 585.17 258.527 585.17 261.15C585.17 263.773 587.297 265.9 589.92 265.9Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.92 284.24C592.543 284.24 594.67 282.113 594.67 279.49C594.67 276.867 592.543 274.74 589.92 274.74C587.297 274.74 585.17 276.867 585.17 279.49C585.17 282.113 587.297 284.24 589.92 284.24Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.92 327.12C592.543 327.12 594.67 324.993 594.67 322.37C594.67 319.747 592.543 317.62 589.92 317.62C587.297 317.62 585.17 319.747 585.17 322.37C585.17 324.993 587.297 327.12 589.92 327.12Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.08 340.27C604.842 340.27 606.27 338.842 606.27 337.08C606.27 335.318 604.842 333.89 603.08 333.89C601.318 333.89 599.89 335.318 599.89 337.08C599.89 338.842 601.318 340.27 603.08 340.27Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.38 335.75H610.59C610.148 335.75 609.79 336.108 609.79 336.55V337.68C609.79 338.122 610.148 338.48 610.59 338.48H629.38C629.822 338.48 630.18 338.122 630.18 337.68V336.55C630.18 336.108 629.822 335.75 629.38 335.75Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M629.38 335.75H610.59C610.148 335.75 609.79 336.108 609.79 336.55V337.68C609.79 338.122 610.148 338.48 610.59 338.48H629.38C629.822 338.48 630.18 338.122 630.18 337.68V336.55C630.18 336.108 629.822 335.75 629.38 335.75Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.08 352.11C604.842 352.11 606.27 350.682 606.27 348.92C606.27 347.158 604.842 345.73 603.08 345.73C601.318 345.73 599.89 347.158 599.89 348.92C599.89 350.682 601.318 352.11 603.08 352.11Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.38 347.58H610.59C610.148 347.58 609.79 347.938 609.79 348.38V349.51C609.79 349.952 610.148 350.31 610.59 350.31H629.38C629.822 350.31 630.18 349.952 630.18 349.51V348.38C630.18 347.938 629.822 347.58 629.38 347.58Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M629.38 347.58H610.59C610.148 347.58 609.79 347.938 609.79 348.38V349.51C609.79 349.952 610.148 350.31 610.59 350.31H629.38C629.822 350.31 630.18 349.952 630.18 349.51V348.38C630.18 347.938 629.822 347.58 629.38 347.58Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.38 278.12H600.69C600.248 278.12 599.89 278.478 599.89 278.92V280.05C599.89 280.492 600.248 280.85 600.69 280.85H629.38C629.822 280.85 630.18 280.492 630.18 280.05V278.92C630.18 278.478 629.822 278.12 629.38 278.12Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M629.38 278.12H600.69C600.248 278.12 599.89 278.478 599.89 278.92V280.05C599.89 280.492 600.248 280.85 600.69 280.85H629.38C629.822 280.85 630.18 280.492 630.18 280.05V278.92C630.18 278.478 629.822 278.12 629.38 278.12Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.38 259.79H600.69C600.248 259.79 599.89 260.148 599.89 260.59V261.72C599.89 262.162 600.248 262.52 600.69 262.52H629.38C629.822 262.52 630.18 262.162 630.18 261.72V260.59C630.18 260.148 629.822 259.79 629.38 259.79Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M629.38 259.79H600.69C600.248 259.79 599.89 260.148 599.89 260.59V261.72C599.89 262.162 600.248 262.52 600.69 262.52H629.38C629.822 262.52 630.18 262.162 630.18 261.72V260.59C630.18 260.148 629.822 259.79 629.38 259.79Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.38 320.19H600.69C600.248 320.19 599.89 320.548 599.89 320.99V322.12C599.89 322.562 600.248 322.92 600.69 322.92H629.38C629.822 322.92 630.18 322.562 630.18 322.12V320.99C630.18 320.548 629.822 320.19 629.38 320.19Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M629.38 320.19H600.69C600.248 320.19 599.89 320.548 599.89 320.99V322.12C599.89 322.562 600.248 322.92 600.69 322.92H629.38C629.822 322.92 630.18 322.562 630.18 322.12V320.99C630.18 320.548 629.822 320.19 629.38 320.19Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.2 259.79H663.17C662.728 259.79 662.37 260.148 662.37 260.59V261.72C662.37 262.162 662.728 262.52 663.17 262.52H721.2C721.642 262.52 722 262.162 722 261.72V260.59C722 260.148 721.642 259.79 721.2 259.79Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.73 259.79H727.37C726.928 259.79 726.57 260.148 726.57 260.59V261.72C726.57 262.162 726.928 262.52 727.37 262.52H770.73C771.172 262.52 771.53 262.162 771.53 261.72V260.59C771.53 260.148 771.172 259.79 770.73 259.79Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.2 320.57H663.17C662.728 320.57 662.37 320.928 662.37 321.37V322.5C662.37 322.942 662.728 323.3 663.17 323.3H721.2C721.642 323.3 722 322.942 722 322.5V321.37C722 320.928 721.642 320.57 721.2 320.57Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.73 320.57H727.37C726.928 320.57 726.57 320.928 726.57 321.37V322.5C726.57 322.942 726.928 323.3 727.37 323.3H770.73C771.172 323.3 771.53 322.942 771.53 322.5V321.37C771.53 320.928 771.172 320.57 770.73 320.57Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.19 335.75H695.44C694.998 335.75 694.64 336.108 694.64 336.55V337.68C694.64 338.122 694.998 338.48 695.44 338.48H721.19C721.632 338.48 721.99 338.122 721.99 337.68V336.55C721.99 336.108 721.632 335.75 721.19 335.75Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.73 335.75H727.37C726.928 335.75 726.57 336.108 726.57 336.55V337.68C726.57 338.122 726.928 338.48 727.37 338.48H770.73C771.172 338.48 771.53 338.122 771.53 337.68V336.55C771.53 336.108 771.172 335.75 770.73 335.75Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.19 347.55H695.44C694.998 347.55 694.64 347.908 694.64 348.35V349.48C694.64 349.922 694.998 350.28 695.44 350.28H721.19C721.632 350.28 721.99 349.922 721.99 349.48V348.35C721.99 347.908 721.632 347.55 721.19 347.55Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.73 347.55H727.37C726.928 347.55 726.57 347.908 726.57 348.35V349.48C726.57 349.922 726.928 350.28 727.37 350.28H770.73C771.172 350.28 771.53 349.922 771.53 349.48V348.35C771.53 347.908 771.172 347.55 770.73 347.55Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.2 278H663.17C662.728 278 662.37 278.358 662.37 278.8V279.93C662.37 280.372 662.728 280.73 663.17 280.73H721.2C721.642 280.73 722 280.372 722 279.93V278.8C722 278.358 721.642 278 721.2 278Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.73 278H727.37C726.928 278 726.57 278.358 726.57 278.8V279.93C726.57 280.372 726.928 280.73 727.37 280.73H770.73C771.172 280.73 771.53 280.372 771.53 279.93V278.8C771.53 278.358 771.172 278 770.73 278Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.19 293.18H695.44C694.998 293.18 694.64 293.538 694.64 293.98V295.11C694.64 295.552 694.998 295.91 695.44 295.91H721.19C721.632 295.91 721.99 295.552 721.99 295.11V293.98C721.99 293.538 721.632 293.18 721.19 293.18Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.73 293.18H727.37C726.928 293.18 726.57 293.538 726.57 293.98V295.11C726.57 295.552 726.928 295.91 727.37 295.91H770.73C771.172 295.91 771.53 295.552 771.53 295.11V293.98C771.53 293.538 771.172 293.18 770.73 293.18Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.19 304.98H695.44C694.998 304.98 694.64 305.338 694.64 305.78V306.91C694.64 307.352 694.998 307.71 695.44 307.71H721.19C721.632 307.71 721.99 307.352 721.99 306.91V305.78C721.99 305.338 721.632 304.98 721.19 304.98Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.73 304.98H727.37C726.928 304.98 726.57 305.338 726.57 305.78V306.91C726.57 307.352 726.928 307.71 727.37 307.71H770.73C771.172 307.71 771.53 307.352 771.53 306.91V305.78C771.53 305.338 771.172 304.98 770.73 304.98Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 164, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      baselineShift: 0,
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M721.19 335.75H695.44C694.998 335.75 694.64 336.108 694.64 336.55V337.68C694.64 338.122 694.998 338.48 695.44 338.48H721.19C721.632 338.48 721.99 338.122 721.99 337.68V336.55C721.99 336.108 721.632 335.75 721.19 335.75Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      baselineShift: 0,
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M770.73 335.75H727.37C726.928 335.75 726.57 336.108 726.57 336.55V337.68C726.57 338.122 726.928 338.48 727.37 338.48H770.73C771.172 338.48 771.53 338.122 771.53 337.68V336.55C771.53 336.108 771.172 335.75 770.73 335.75Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      baselineShift: 0,
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M721.19 347.55H695.44C694.998 347.55 694.64 347.908 694.64 348.35V349.48C694.64 349.922 694.998 350.28 695.44 350.28H721.19C721.632 350.28 721.99 349.922 721.99 349.48V348.35C721.99 347.908 721.632 347.55 721.19 347.55Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      baselineShift: 0,
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M770.73 347.55H727.37C726.928 347.55 726.57 347.908 726.57 348.35V349.48C726.57 349.922 726.928 350.28 727.37 350.28H770.73C771.172 350.28 771.53 349.922 771.53 349.48V348.35C771.53 347.908 771.172 347.55 770.73 347.55Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      baselineShift: 0,
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M721.19 293.18H695.44C694.998 293.18 694.64 293.538 694.64 293.98V295.11C694.64 295.552 694.998 295.91 695.44 295.91H721.19C721.632 295.91 721.99 295.552 721.99 295.11V293.98C721.99 293.538 721.632 293.18 721.19 293.18Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      baselineShift: 0,
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M770.73 293.18H727.37C726.928 293.18 726.57 293.538 726.57 293.98V295.11C726.57 295.552 726.928 295.91 727.37 295.91H770.73C771.172 295.91 771.53 295.552 771.53 295.11V293.98C771.53 293.538 771.172 293.18 770.73 293.18Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      baselineShift: 0,
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M721.19 304.98H695.44C694.998 304.98 694.64 305.338 694.64 305.78V306.91C694.64 307.352 694.998 307.71 695.44 307.71H721.19C721.632 307.71 721.99 307.352 721.99 306.91V305.78C721.99 305.338 721.632 304.98 721.19 304.98Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      baselineShift: 0,
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M770.73 304.98H727.37C726.928 304.98 726.57 305.338 726.57 305.78V306.91C726.57 307.352 726.928 307.71 727.37 307.71H770.73C771.172 307.71 771.53 307.352 771.53 306.91V305.78C771.53 305.338 771.172 304.98 770.73 304.98Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M585.18 236.56C586.224 236.56 587.07 235.714 587.07 234.67C587.07 233.626 586.224 232.78 585.18 232.78C584.136 232.78 583.29 233.626 583.29 234.67C583.29 235.714 584.136 236.56 585.18 236.56Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.85,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M594.04 236.56C595.084 236.56 595.93 235.714 595.93 234.67C595.93 233.626 595.084 232.78 594.04 232.78C592.996 232.78 592.15 233.626 592.15 234.67C592.15 235.714 592.996 236.56 594.04 236.56Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.85,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M602.91 236.56C603.954 236.56 604.8 235.714 604.8 234.67C604.8 233.626 603.954 232.78 602.91 232.78C601.866 232.78 601.02 233.626 601.02 234.67C601.02 235.714 601.866 236.56 602.91 236.56Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.85,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M589.92 265.9C592.543 265.9 594.67 263.773 594.67 261.15C594.67 258.527 592.543 256.4 589.92 256.4C587.297 256.4 585.17 258.527 585.17 261.15C585.17 263.773 587.297 265.9 589.92 265.9Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M589.92 284.24C592.543 284.24 594.67 282.113 594.67 279.49C594.67 276.867 592.543 274.74 589.92 274.74C587.297 274.74 585.17 276.867 585.17 279.49C585.17 282.113 587.297 284.24 589.92 284.24Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M589.92 327.12C592.543 327.12 594.67 324.993 594.67 322.37C594.67 319.747 592.543 317.62 589.92 317.62C587.297 317.62 585.17 319.747 585.17 322.37C585.17 324.993 587.297 327.12 589.92 327.12Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M792.66 414.19C809.295 414.19 822.78 400.705 822.78 384.07C822.78 367.435 809.295 353.95 792.66 353.95C776.025 353.95 762.54 367.435 762.54 384.07C762.54 400.705 776.025 414.19 792.66 414.19Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.28 414.19C804.915 414.19 818.4 400.705 818.4 384.07C818.4 367.435 804.915 353.95 788.28 353.95C771.645 353.95 758.16 367.435 758.16 384.07C758.16 400.705 771.645 414.19 788.28 414.19Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M788.28 414.19C804.915 414.19 818.4 400.705 818.4 384.07C818.4 367.435 804.915 353.95 788.28 353.95C771.645 353.95 758.16 367.435 758.16 384.07C758.16 400.705 771.645 414.19 788.28 414.19Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.28 409.69C783.212 409.692 778.258 408.191 774.043 405.377C769.829 402.563 766.544 398.563 764.603 393.881C762.662 389.2 762.154 384.048 763.141 379.078C764.128 374.107 766.568 369.541 770.15 365.957C773.733 362.373 778.298 359.932 783.268 358.943C788.238 357.954 793.39 358.46 798.072 360.399C802.754 362.338 806.756 365.622 809.571 369.835C812.387 374.049 813.89 379.002 813.89 384.07C813.882 390.861 811.182 397.371 806.381 402.174C801.58 406.976 795.071 409.679 788.28 409.69ZM788.28 359.45C783.41 359.448 778.649 360.89 774.599 363.594C770.549 366.298 767.392 370.143 765.527 374.641C763.662 379.14 763.173 384.091 764.122 388.867C765.071 393.643 767.415 398.031 770.857 401.475C774.3 404.92 778.687 407.265 783.463 408.216C788.239 409.167 793.19 408.68 797.689 406.817C802.189 404.954 806.034 401.798 808.74 397.749C811.446 393.7 812.89 388.94 812.89 384.07C812.885 377.544 810.29 371.286 805.677 366.67C801.063 362.055 794.806 359.458 788.28 359.45V359.45Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.82 395.94C782.491 395.941 782.166 395.877 781.862 395.752C781.558 395.627 781.282 395.442 781.05 395.21L772.49 386.65C772.035 386.178 771.784 385.546 771.791 384.89C771.797 384.235 772.061 383.608 772.525 383.145C772.989 382.683 773.617 382.42 774.272 382.416C774.928 382.411 775.559 382.664 776.03 383.12L782.82 389.91L798.9 373.83C799.376 373.404 799.997 373.177 800.636 373.195C801.275 373.213 801.882 373.474 802.334 373.926C802.786 374.378 803.047 374.985 803.065 375.624C803.083 376.263 802.856 376.884 802.43 377.36L784.58 395.21C784.35 395.442 784.075 395.626 783.773 395.752C783.471 395.877 783.147 395.941 782.82 395.94V395.94Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.14 423.34H523.68C521.079 423.34 518.97 425.449 518.97 428.05V450.63C518.97 453.231 521.079 455.34 523.68 455.34H572.14C574.741 455.34 576.85 453.231 576.85 450.63V428.05C576.85 425.449 574.741 423.34 572.14 423.34Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M572.14 423.34H523.68C521.079 423.34 518.97 425.449 518.97 428.05V450.63C518.97 453.231 521.079 455.34 523.68 455.34H572.14C574.741 455.34 576.85 453.231 576.85 450.63V428.05C576.85 425.449 574.741 423.34 572.14 423.34Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.45,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.09 436.03H529.4C528.897 436.03 528.49 436.437 528.49 436.94V437.85C528.49 438.353 528.897 438.76 529.4 438.76H537.09C537.593 438.76 538 438.353 538 437.85V436.94C538 436.437 537.593 436.03 537.09 436.03Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.14 436.03H541.95C541.447 436.03 541.04 436.437 541.04 436.94V437.85C541.04 438.353 541.447 438.76 541.95 438.76H568.14C568.643 438.76 569.05 438.353 569.05 437.85V436.94C569.05 436.437 568.643 436.03 568.14 436.03Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.09 444.02H529.4C528.897 444.02 528.49 444.427 528.49 444.93V445.84C528.49 446.343 528.897 446.75 529.4 446.75H537.09C537.593 446.75 538 446.343 538 445.84V444.93C538 444.427 537.593 444.02 537.09 444.02Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.14 444.02H541.95C541.447 444.02 541.04 444.427 541.04 444.93V445.84C541.04 446.343 541.447 446.75 541.95 446.75H558.14C558.643 446.75 559.05 446.343 559.05 445.84V444.93C559.05 444.427 558.643 444.02 558.14 444.02Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.14 423.34H523.67C523.052 423.34 522.44 423.462 521.869 423.699C521.298 423.936 520.78 424.283 520.343 424.72C519.907 425.158 519.561 425.677 519.325 426.248C519.089 426.82 518.969 427.432 518.97 428.05V429.66H576.85V428.05C576.85 426.801 576.354 425.603 575.47 424.72C574.587 423.836 573.389 423.34 572.14 423.34V423.34Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.64 423.34H522.18C519.579 423.34 517.47 425.449 517.47 428.05V450.63C517.47 453.231 519.579 455.34 522.18 455.34H570.64C573.241 455.34 575.35 453.231 575.35 450.63V428.05C575.35 425.449 573.241 423.34 570.64 423.34Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M570.64 423.34H522.18C519.579 423.34 517.47 425.449 517.47 428.05V450.63C517.47 453.231 519.579 455.34 522.18 455.34H570.64C573.241 455.34 575.35 453.231 575.35 450.63V428.05C575.35 425.449 573.241 423.34 570.64 423.34Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.6 436.03H527.91C527.407 436.03 527 436.437 527 436.94V437.85C527 438.353 527.407 438.76 527.91 438.76H535.6C536.103 438.76 536.51 438.353 536.51 437.85V436.94C536.51 436.437 536.103 436.03 535.6 436.03Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.65 436.03H540.46C539.958 436.03 539.55 436.437 539.55 436.94V437.85C539.55 438.353 539.958 438.76 540.46 438.76H566.65C567.153 438.76 567.56 438.353 567.56 437.85V436.94C567.56 436.437 567.153 436.03 566.65 436.03Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.6 444.02H527.91C527.407 444.02 527 444.427 527 444.93V445.84C527 446.343 527.407 446.75 527.91 446.75H535.6C536.103 446.75 536.51 446.343 536.51 445.84V444.93C536.51 444.427 536.103 444.02 535.6 444.02Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.65 444.02H540.46C539.958 444.02 539.55 444.427 539.55 444.93V445.84C539.55 446.343 539.958 446.75 540.46 446.75H556.65C557.153 446.75 557.56 446.343 557.56 445.84V444.93C557.56 444.427 557.153 444.02 556.65 444.02Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.65 423.34H522.18C521.561 423.34 520.949 423.462 520.378 423.699C519.806 423.935 519.287 424.282 518.85 424.72C518.412 425.157 518.065 425.676 517.829 426.248C517.592 426.819 517.47 427.431 517.47 428.05V429.66H575.35V428.05C575.351 427.432 575.231 426.82 574.995 426.248C574.76 425.677 574.413 425.158 573.977 424.72C573.54 424.283 573.022 423.936 572.451 423.699C571.88 423.462 571.268 423.34 570.65 423.34V423.34Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.12 250.2H850.66C848.059 250.2 845.95 252.309 845.95 254.91V277.49C845.95 280.091 848.059 282.2 850.66 282.2H899.12C901.721 282.2 903.83 280.091 903.83 277.49V254.91C903.83 252.309 901.721 250.2 899.12 250.2Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M899.12 250.2H850.66C848.059 250.2 845.95 252.309 845.95 254.91V277.49C845.95 280.091 848.059 282.2 850.66 282.2H899.12C901.721 282.2 903.83 280.091 903.83 277.49V254.91C903.83 252.309 901.721 250.2 899.12 250.2Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.45,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.08 262.89H856.39C855.887 262.89 855.48 263.297 855.48 263.8V264.71C855.48 265.213 855.887 265.62 856.39 265.62H864.08C864.583 265.62 864.99 265.213 864.99 264.71V263.8C864.99 263.297 864.583 262.89 864.08 262.89Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.12 262.89H868.93C868.427 262.89 868.02 263.297 868.02 263.8V264.71C868.02 265.213 868.427 265.62 868.93 265.62H895.12C895.623 265.62 896.03 265.213 896.03 264.71V263.8C896.03 263.297 895.623 262.89 895.12 262.89Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.08 270.87H856.39C855.887 270.87 855.48 271.277 855.48 271.78V272.69C855.48 273.193 855.887 273.6 856.39 273.6H864.08C864.583 273.6 864.99 273.193 864.99 272.69V271.78C864.99 271.277 864.583 270.87 864.08 270.87Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.12 270.87H868.93C868.427 270.87 868.02 271.277 868.02 271.78V272.69C868.02 273.193 868.427 273.6 868.93 273.6H885.12C885.623 273.6 886.03 273.193 886.03 272.69V271.78C886.03 271.277 885.623 270.87 885.12 270.87Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.12 250.2H850.65C850.032 250.199 849.421 250.319 848.85 250.555C848.279 250.791 847.76 251.137 847.324 251.574C846.887 252.01 846.541 252.529 846.305 253.1C846.069 253.671 845.949 254.282 845.95 254.9V256.52H903.83V254.9C903.83 254.282 903.708 253.67 903.471 253.099C903.234 252.528 902.887 252.01 902.45 251.573C902.012 251.136 901.493 250.79 900.922 250.555C900.35 250.319 899.738 250.199 899.12 250.2Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.62 250.2H849.16C846.559 250.2 844.45 252.309 844.45 254.91V277.49C844.45 280.091 846.559 282.2 849.16 282.2H897.62C900.221 282.2 902.33 280.091 902.33 277.49V254.91C902.33 252.309 900.221 250.2 897.62 250.2Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M897.62 250.2H849.16C846.559 250.2 844.45 252.309 844.45 254.91V277.49C844.45 280.091 846.559 282.2 849.16 282.2H897.62C900.221 282.2 902.33 280.091 902.33 277.49V254.91C902.33 252.309 900.221 250.2 897.62 250.2Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.58 262.89H854.89C854.387 262.89 853.98 263.297 853.98 263.8V264.71C853.98 265.213 854.387 265.62 854.89 265.62H862.58C863.083 265.62 863.49 265.213 863.49 264.71V263.8C863.49 263.297 863.083 262.89 862.58 262.89Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.63 262.89H867.44C866.937 262.89 866.53 263.297 866.53 263.8V264.71C866.53 265.213 866.937 265.62 867.44 265.62H893.63C894.133 265.62 894.54 265.213 894.54 264.71V263.8C894.54 263.297 894.133 262.89 893.63 262.89Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.58 270.87H854.89C854.387 270.87 853.98 271.277 853.98 271.78V272.69C853.98 273.193 854.387 273.6 854.89 273.6H862.58C863.083 273.6 863.49 273.193 863.49 272.69V271.78C863.49 271.277 863.083 270.87 862.58 270.87Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.63 270.87H867.44C866.937 270.87 866.53 271.277 866.53 271.78V272.69C866.53 273.193 866.937 273.6 867.44 273.6H883.63C884.133 273.6 884.54 273.193 884.54 272.69V271.78C884.54 271.277 884.133 270.87 883.63 270.87Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.63 250.2H849.16C848.542 250.199 847.93 250.319 847.358 250.555C846.787 250.79 846.268 251.136 845.83 251.573C845.393 252.01 845.045 252.528 844.809 253.099C844.572 253.67 844.45 254.282 844.45 254.9V256.52H902.34V254.9C902.34 254.282 902.218 253.67 901.981 253.099C901.744 252.528 901.397 252.01 900.96 251.573C900.522 251.136 900.003 250.79 899.432 250.555C898.86 250.319 898.248 250.199 897.63 250.2V250.2Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.07 328.53H968.61C966.009 328.53 963.9 330.639 963.9 333.24V355.82C963.9 358.421 966.009 360.53 968.61 360.53H1017.07C1019.67 360.53 1021.78 358.421 1021.78 355.82V333.24C1021.78 330.639 1019.67 328.53 1017.07 328.53Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M1017.07 328.53H968.61C966.009 328.53 963.9 330.639 963.9 333.24V355.82C963.9 358.421 966.009 360.53 968.61 360.53H1017.07C1019.67 360.53 1021.78 358.421 1021.78 355.82V333.24C1021.78 330.639 1019.67 328.53 1017.07 328.53Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.45,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.02 341.22H974.33C973.827 341.22 973.42 341.627 973.42 342.13V343.04C973.42 343.543 973.827 343.95 974.33 343.95H982.02C982.523 343.95 982.93 343.543 982.93 343.04V342.13C982.93 341.627 982.523 341.22 982.02 341.22Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.07 341.22H986.88C986.377 341.22 985.97 341.627 985.97 342.13V343.04C985.97 343.543 986.377 343.95 986.88 343.95H1013.07C1013.57 343.95 1013.98 343.543 1013.98 343.04V342.13C1013.98 341.627 1013.57 341.22 1013.07 341.22Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.02 349.21H974.33C973.827 349.21 973.42 349.617 973.42 350.12V351.03C973.42 351.533 973.827 351.94 974.33 351.94H982.02C982.523 351.94 982.93 351.533 982.93 351.03V350.12C982.93 349.617 982.523 349.21 982.02 349.21Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.07 349.21H986.88C986.377 349.21 985.97 349.617 985.97 350.12V351.03C985.97 351.533 986.377 351.94 986.88 351.94H1003.07C1003.57 351.94 1003.98 351.533 1003.98 351.03V350.12C1003.98 349.617 1003.57 349.21 1003.07 349.21Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.07 328.53H968.6C967.982 328.53 967.37 328.652 966.799 328.889C966.228 329.126 965.71 329.473 965.273 329.91C964.836 330.348 964.49 330.867 964.255 331.438C964.019 332.01 963.899 332.622 963.9 333.24V334.85H1021.78V333.24C1021.78 331.991 1021.28 330.793 1020.4 329.91C1019.52 329.026 1018.32 328.53 1017.07 328.53Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.57 328.53H967.11C964.509 328.53 962.4 330.639 962.4 333.24V355.82C962.4 358.421 964.509 360.53 967.11 360.53H1015.57C1018.17 360.53 1020.28 358.421 1020.28 355.82V333.24C1020.28 330.639 1018.17 328.53 1015.57 328.53Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1015.57 328.53H967.11C964.509 328.53 962.4 330.639 962.4 333.24V355.82C962.4 358.421 964.509 360.53 967.11 360.53H1015.57C1018.17 360.53 1020.28 358.421 1020.28 355.82V333.24C1020.28 330.639 1018.17 328.53 1015.57 328.53Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.53 341.22H972.84C972.338 341.22 971.93 341.627 971.93 342.13V343.04C971.93 343.543 972.338 343.95 972.84 343.95H980.53C981.033 343.95 981.44 343.543 981.44 343.04V342.13C981.44 341.627 981.033 341.22 980.53 341.22Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.58 341.22H985.39C984.887 341.22 984.48 341.627 984.48 342.13V343.04C984.48 343.543 984.887 343.95 985.39 343.95H1011.58C1012.08 343.95 1012.49 343.543 1012.49 343.04V342.13C1012.49 341.627 1012.08 341.22 1011.58 341.22Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.53 349.21H972.84C972.338 349.21 971.93 349.617 971.93 350.12V351.03C971.93 351.533 972.338 351.94 972.84 351.94H980.53C981.033 351.94 981.44 351.533 981.44 351.03V350.12C981.44 349.617 981.033 349.21 980.53 349.21Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1001.58 349.21H985.39C984.887 349.21 984.48 349.617 984.48 350.12V351.03C984.48 351.533 984.887 351.94 985.39 351.94H1001.58C1002.08 351.94 1002.49 351.533 1002.49 351.03V350.12C1002.49 349.617 1002.08 349.21 1001.58 349.21Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.58 328.53H967.11C965.861 328.53 964.663 329.026 963.779 329.91C962.896 330.793 962.4 331.991 962.4 333.24V334.85H1020.28V333.24C1020.28 332.622 1020.16 332.01 1019.92 331.438C1019.69 330.867 1019.34 330.348 1018.91 329.91C1018.47 329.473 1017.95 329.126 1017.38 328.889C1016.81 328.652 1016.2 328.53 1015.58 328.53V328.53Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1490.24 961.6H109.75V962.6H1490.24V961.6Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(0, 86, 186)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1490.24 961.6H109.75V962.6H1490.24V961.6Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/Hero.cb24fda1f9b080e31792deeb2693b90d.svg";
export { ForwardRef as ReactComponent };